import { jsx as v, jsxs as Q, Fragment as rs } from "react/jsx-runtime";
import * as O from "react";
import U, { createContext as ss, useContext as as, useCallback as $a, useState as Me, useRef as os, useEffect as pt, useMemo as is, createElement as Na, forwardRef as Jn } from "react";
import { l as br, c as Oa, n as ls, s as Ta } from "./stay-request-BY2pwx-a.js";
import { f as pp, i as mp, h as _p, a as bp, g as vp, b as yp, e as wp, d as xp, j as kp, k as Sp, m as $p, p as Np, u as Op } from "./stay-request-BY2pwx-a.js";
var Ht = (n) => n.type === "checkbox", Xe = (n) => n instanceof Date, pe = (n) => n == null;
const cs = (n) => typeof n == "object";
var se = (n) => !pe(n) && !Array.isArray(n) && cs(n) && !Xe(n), us = (n) => se(n) && n.target ? Ht(n.target) ? n.target.checked : n.target.value : n, Ea = (n) => n.substring(0, n.search(/\.\d+(\.|$)/)) || n, ds = (n, e) => n.has(Ea(e)), Ca = (n) => {
  const e = n.constructor && n.constructor.prototype;
  return se(e) && e.hasOwnProperty("isPrototypeOf");
}, Qn = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function be(n) {
  let e;
  const t = Array.isArray(n), r = typeof FileList < "u" ? n instanceof FileList : !1;
  if (n instanceof Date)
    e = new Date(n);
  else if (n instanceof Set)
    e = new Set(n);
  else if (!(Qn && (n instanceof Blob || r)) && (t || se(n)))
    if (e = t ? [] : {}, !t && !Ca(n))
      e = n;
    else
      for (const s in n)
        n.hasOwnProperty(s) && (e[s] = be(n[s]));
  else
    return n;
  return e;
}
var xn = (n) => Array.isArray(n) ? n.filter(Boolean) : [], ne = (n) => n === void 0, S = (n, e, t) => {
  if (!e || !se(n))
    return t;
  const r = xn(e.split(/[,[\].]+?/)).reduce((s, a) => pe(s) ? s : s[a], n);
  return ne(r) || r === n ? ne(n[e]) ? t : n[e] : r;
}, ke = (n) => typeof n == "boolean", Xn = (n) => /^\w*$/.test(n), fs = (n) => xn(n.replace(/["|']|\]/g, "").split(/\.|\[/)), Y = (n, e, t) => {
  let r = -1;
  const s = Xn(e) ? [e] : fs(e), a = s.length, o = a - 1;
  for (; ++r < a; ) {
    const i = s[r];
    let c = t;
    if (r !== o) {
      const l = n[i];
      c = se(l) || Array.isArray(l) ? l : isNaN(+s[r + 1]) ? {} : [];
    }
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return;
    n[i] = c, n = n[i];
  }
  return n;
};
const nn = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ne = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, je = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Ra = U.createContext(null), er = () => U.useContext(Ra);
var hs = (n, e, t, r = !0) => {
  const s = {
    defaultValues: e._defaultValues
  };
  for (const a in n)
    Object.defineProperty(s, a, {
      get: () => {
        const o = a;
        return e._proxyFormState[o] !== Ne.all && (e._proxyFormState[o] = !r || Ne.all), t && (t[o] = !0), n[o];
      }
    });
  return s;
}, ve = (n) => se(n) && !Object.keys(n).length, gs = (n, e, t, r) => {
  t(n);
  const { name: s, ...a } = n;
  return ve(a) || Object.keys(a).length >= Object.keys(e).length || Object.keys(a).find((o) => e[o] === (!r || Ne.all));
}, Tt = (n) => Array.isArray(n) ? n : [n], ps = (n, e, t) => !n || !e || n === e || Tt(n).some((r) => r && (t ? r === e : r.startsWith(e) || e.startsWith(r)));
function tr(n) {
  const e = U.useRef(n);
  e.current = n, U.useEffect(() => {
    const t = !n.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [n.disabled]);
}
function Aa(n) {
  const e = er(), { control: t = e.control, disabled: r, name: s, exact: a } = n || {}, [o, i] = U.useState(t._formState), c = U.useRef(!0), l = U.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), f = U.useRef(s);
  return f.current = s, tr({
    disabled: r,
    next: (d) => c.current && ps(f.current, d.name, a) && gs(d, l.current, t._updateFormState) && i({
      ...t._formState,
      ...d
    }),
    subject: t._subjects.state
  }), U.useEffect(() => (c.current = !0, l.current.isValid && t._updateValid(!0), () => {
    c.current = !1;
  }), [t]), U.useMemo(() => hs(o, t, l.current, !1), [o, t]);
}
var Re = (n) => typeof n == "string", ms = (n, e, t, r, s) => Re(n) ? (r && e.watch.add(n), S(t, n, s)) : Array.isArray(n) ? n.map((a) => (r && e.watch.add(a), S(t, a))) : (r && (e.watchAll = !0), t);
function za(n) {
  const e = er(), { control: t = e.control, name: r, defaultValue: s, disabled: a, exact: o } = n || {}, i = U.useRef(r);
  i.current = r, tr({
    disabled: a,
    subject: t._subjects.values,
    next: (f) => {
      ps(i.current, f.name, o) && l(be(ms(i.current, t._names, f.values || t._formValues, !1, s)));
    }
  });
  const [c, l] = U.useState(t._getWatch(r, s));
  return U.useEffect(() => t._removeUnmounted()), c;
}
function Da(n) {
  const e = er(), { name: t, disabled: r, control: s = e.control, shouldUnregister: a } = n, o = ds(s._names.array, t), i = za({
    control: s,
    name: t,
    defaultValue: S(s._formValues, t, S(s._defaultValues, t, n.defaultValue)),
    exact: !0
  }), c = Aa({
    control: s,
    name: t,
    exact: !0
  }), l = U.useRef(s.register(t, {
    ...n.rules,
    value: i,
    ...ke(n.disabled) ? { disabled: n.disabled } : {}
  })), f = U.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!S(c.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!S(c.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!S(c.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!S(c.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => S(c.errors, t)
    }
  }), [c, t]), d = U.useMemo(() => ({
    name: t,
    value: i,
    ...ke(r) || c.disabled ? { disabled: c.disabled || r } : {},
    onChange: (u) => l.current.onChange({
      target: {
        value: us(u),
        name: t
      },
      type: nn.CHANGE
    }),
    onBlur: () => l.current.onBlur({
      target: {
        value: S(s._formValues, t),
        name: t
      },
      type: nn.BLUR
    }),
    ref: (u) => {
      const g = S(s._fields, t);
      g && u && (g._f.ref = {
        focus: () => u.focus(),
        select: () => u.select(),
        setCustomValidity: (m) => u.setCustomValidity(m),
        reportValidity: () => u.reportValidity()
      });
    }
  }), [
    t,
    s._formValues,
    r,
    c.disabled,
    i,
    s._fields
  ]);
  return U.useEffect(() => {
    const u = s._options.shouldUnregister || a, g = (m, b) => {
      const y = S(s._fields, m);
      y && y._f && (y._f.mount = b);
    };
    if (g(t, !0), u) {
      const m = be(S(s._options.defaultValues, t));
      Y(s._defaultValues, t, m), ne(S(s._formValues, t)) && Y(s._formValues, t, m);
    }
    return !o && s.register(t), () => {
      (o ? u && !s._state.action : u) ? s.unregister(t) : g(t, !1);
    };
  }, [t, s, o, a]), U.useEffect(() => {
    s._updateDisabledField({
      disabled: r,
      fields: s._fields,
      name: t
    });
  }, [r, t, s]), U.useMemo(() => ({
    field: d,
    formState: c,
    fieldState: f
  }), [d, c, f]);
}
const vr = (n) => n.render(Da(n));
var _s = (n, e, t, r, s) => e ? {
  ...t[n],
  types: {
    ...t[n] && t[n].types ? t[n].types : {},
    [r]: s || !0
  }
} : {}, yr = (n) => ({
  isOnSubmit: !n || n === Ne.onSubmit,
  isOnBlur: n === Ne.onBlur,
  isOnChange: n === Ne.onChange,
  isOnAll: n === Ne.all,
  isOnTouch: n === Ne.onTouched
}), wr = (n, e, t) => !t && (e.watchAll || e.watch.has(n) || [...e.watch].some((r) => n.startsWith(r) && /^\.\w+/.test(n.slice(r.length))));
const Et = (n, e, t, r) => {
  for (const s of t || Object.keys(n)) {
    const a = S(n, s);
    if (a) {
      const { _f: o, ...i } = a;
      if (o) {
        if (o.refs && o.refs[0] && e(o.refs[0], s) && !r)
          return !0;
        if (o.ref && e(o.ref, o.name) && !r)
          return !0;
        if (Et(i, e))
          break;
      } else if (se(i) && Et(i, e))
        break;
    }
  }
};
var La = (n, e, t) => {
  const r = Tt(S(n, t));
  return Y(r, "root", e[t]), Y(n, t, r), n;
}, nr = (n) => n.type === "file", Ce = (n) => typeof n == "function", rn = (n) => {
  if (!Qn)
    return !1;
  const e = n ? n.ownerDocument : 0;
  return n instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, tn = (n) => Re(n), rr = (n) => n.type === "radio", sn = (n) => n instanceof RegExp;
const xr = {
  value: !1,
  isValid: !1
}, kr = { value: !0, isValid: !0 };
var bs = (n) => {
  if (Array.isArray(n)) {
    if (n.length > 1) {
      const e = n.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: e, isValid: !!e.length };
    }
    return n[0].checked && !n[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      n[0].attributes && !ne(n[0].attributes.value) ? ne(n[0].value) || n[0].value === "" ? kr : { value: n[0].value, isValid: !0 } : kr
    ) : xr;
  }
  return xr;
};
const Sr = {
  isValid: !1,
  value: null
};
var vs = (n) => Array.isArray(n) ? n.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : e, Sr) : Sr;
function $r(n, e, t = "validate") {
  if (tn(n) || Array.isArray(n) && n.every(tn) || ke(n) && !n)
    return {
      type: t,
      message: tn(n) ? n : "",
      ref: e
    };
}
var at = (n) => se(n) && !sn(n) ? n : {
  value: n,
  message: ""
}, Nr = async (n, e, t, r, s, a) => {
  const { ref: o, refs: i, required: c, maxLength: l, minLength: f, min: d, max: u, pattern: g, validate: m, name: b, valueAsNumber: y, mount: R } = n._f, k = S(t, b);
  if (!R || e.has(b))
    return {};
  const F = i ? i[0] : o, J = (z) => {
    s && F.reportValidity && (F.setCustomValidity(ke(z) ? "" : z || ""), F.reportValidity());
  }, H = {}, ce = rr(o), X = Ht(o), D = ce || X, ee = (y || nr(o)) && ne(o.value) && ne(k) || rn(o) && o.value === "" || k === "" || Array.isArray(k) && !k.length, W = _s.bind(null, b, r, H), G = (z, Z, K, B = je.maxLength, ue = je.minLength) => {
    const de = z ? Z : K;
    H[b] = {
      type: z ? B : ue,
      message: de,
      ref: o,
      ...W(z ? B : ue, de)
    };
  };
  if (a ? !Array.isArray(k) || !k.length : c && (!D && (ee || pe(k)) || ke(k) && !k || X && !bs(i).isValid || ce && !vs(i).isValid)) {
    const { value: z, message: Z } = tn(c) ? { value: !!c, message: c } : at(c);
    if (z && (H[b] = {
      type: je.required,
      message: Z,
      ref: F,
      ...W(je.required, Z)
    }, !r))
      return J(Z), H;
  }
  if (!ee && (!pe(d) || !pe(u))) {
    let z, Z;
    const K = at(u), B = at(d);
    if (!pe(k) && !isNaN(k)) {
      const ue = o.valueAsNumber || k && +k;
      pe(K.value) || (z = ue > K.value), pe(B.value) || (Z = ue < B.value);
    } else {
      const ue = o.valueAsDate || new Date(k), de = (ye) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + ye), Be = o.type == "time", ae = o.type == "week";
      Re(K.value) && k && (z = Be ? de(k) > de(K.value) : ae ? k > K.value : ue > new Date(K.value)), Re(B.value) && k && (Z = Be ? de(k) < de(B.value) : ae ? k < B.value : ue < new Date(B.value));
    }
    if ((z || Z) && (G(!!z, K.message, B.message, je.max, je.min), !r))
      return J(H[b].message), H;
  }
  if ((l || f) && !ee && (Re(k) || a && Array.isArray(k))) {
    const z = at(l), Z = at(f), K = !pe(z.value) && k.length > +z.value, B = !pe(Z.value) && k.length < +Z.value;
    if ((K || B) && (G(K, z.message, Z.message), !r))
      return J(H[b].message), H;
  }
  if (g && !ee && Re(k)) {
    const { value: z, message: Z } = at(g);
    if (sn(z) && !k.match(z) && (H[b] = {
      type: je.pattern,
      message: Z,
      ref: o,
      ...W(je.pattern, Z)
    }, !r))
      return J(Z), H;
  }
  if (m) {
    if (Ce(m)) {
      const z = await m(k, t), Z = $r(z, F);
      if (Z && (H[b] = {
        ...Z,
        ...W(je.validate, Z.message)
      }, !r))
        return J(Z.message), H;
    } else if (se(m)) {
      let z = {};
      for (const Z in m) {
        if (!ve(z) && !r)
          break;
        const K = $r(await m[Z](k, t), F, Z);
        K && (z = {
          ...K,
          ...W(Z, K.message)
        }, J(K.message), r && (H[b] = z));
      }
      if (!ve(z) && (H[b] = {
        ref: F,
        ...z
      }, !r))
        return H;
    }
  }
  return J(!0), H;
};
function ja(n, e) {
  const t = e.slice(0, -1).length;
  let r = 0;
  for (; r < t; )
    n = ne(n) ? r++ : n[e[r++]];
  return n;
}
function Pa(n) {
  for (const e in n)
    if (n.hasOwnProperty(e) && !ne(n[e]))
      return !1;
  return !0;
}
function oe(n, e) {
  const t = Array.isArray(e) ? e : Xn(e) ? [e] : fs(e), r = t.length === 1 ? n : ja(n, t), s = t.length - 1, a = t[s];
  return r && delete r[a], s !== 0 && (se(r) && ve(r) || Array.isArray(r) && Pa(r)) && oe(n, t.slice(0, -1)), n;
}
var Rn = () => {
  let n = [];
  return {
    get observers() {
      return n;
    },
    next: (s) => {
      for (const a of n)
        a.next && a.next(s);
    },
    subscribe: (s) => (n.push(s), {
      unsubscribe: () => {
        n = n.filter((a) => a !== s);
      }
    }),
    unsubscribe: () => {
      n = [];
    }
  };
}, Vn = (n) => pe(n) || !cs(n);
function Ge(n, e) {
  if (Vn(n) || Vn(e))
    return n === e;
  if (Xe(n) && Xe(e))
    return n.getTime() === e.getTime();
  const t = Object.keys(n), r = Object.keys(e);
  if (t.length !== r.length)
    return !1;
  for (const s of t) {
    const a = n[s];
    if (!r.includes(s))
      return !1;
    if (s !== "ref") {
      const o = e[s];
      if (Xe(a) && Xe(o) || se(a) && se(o) || Array.isArray(a) && Array.isArray(o) ? !Ge(a, o) : a !== o)
        return !1;
    }
  }
  return !0;
}
var ys = (n) => n.type === "select-multiple", Ia = (n) => rr(n) || Ht(n), An = (n) => rn(n) && n.isConnected, ws = (n) => {
  for (const e in n)
    if (Ce(n[e]))
      return !0;
  return !1;
};
function an(n, e = {}) {
  const t = Array.isArray(n);
  if (se(n) || t)
    for (const r in n)
      Array.isArray(n[r]) || se(n[r]) && !ws(n[r]) ? (e[r] = Array.isArray(n[r]) ? [] : {}, an(n[r], e[r])) : pe(n[r]) || (e[r] = !0);
  return e;
}
function xs(n, e, t) {
  const r = Array.isArray(n);
  if (se(n) || r)
    for (const s in n)
      Array.isArray(n[s]) || se(n[s]) && !ws(n[s]) ? ne(e) || Vn(t[s]) ? t[s] = Array.isArray(n[s]) ? an(n[s], []) : { ...an(n[s]) } : xs(n[s], pe(e) ? {} : e[s], t[s]) : t[s] = !Ge(n[s], e[s]);
  return t;
}
var kt = (n, e) => xs(n, e, an(e)), ks = (n, { valueAsNumber: e, valueAsDate: t, setValueAs: r }) => ne(n) ? n : e ? n === "" ? NaN : n && +n : t && Re(n) ? new Date(n) : r ? r(n) : n;
function zn(n) {
  const e = n.ref;
  return nr(e) ? e.files : rr(e) ? vs(n.refs).value : ys(e) ? [...e.selectedOptions].map(({ value: t }) => t) : Ht(e) ? bs(n.refs).value : ks(ne(e.value) ? n.ref.value : e.value, n);
}
var Va = (n, e, t, r) => {
  const s = {};
  for (const a of n) {
    const o = S(e, a);
    o && Y(s, a, o._f);
  }
  return {
    criteriaMode: t,
    names: [...n],
    fields: s,
    shouldUseNativeValidation: r
  };
}, St = (n) => ne(n) ? n : sn(n) ? n.source : se(n) ? sn(n.value) ? n.value.source : n.value : n;
const Or = "AsyncFunction";
var Fa = (n) => !!n && !!n.validate && !!(Ce(n.validate) && n.validate.constructor.name === Or || se(n.validate) && Object.values(n.validate).find((e) => e.constructor.name === Or)), Ma = (n) => n.mount && (n.required || n.min || n.max || n.maxLength || n.minLength || n.pattern || n.validate);
function Tr(n, e, t) {
  const r = S(n, t);
  if (r || Xn(t))
    return {
      error: r,
      name: t
    };
  const s = t.split(".");
  for (; s.length; ) {
    const a = s.join("."), o = S(e, a), i = S(n, a);
    if (o && !Array.isArray(o) && t !== a)
      return { name: t };
    if (i && i.type)
      return {
        name: a,
        error: i
      };
    s.pop();
  }
  return {
    name: t
  };
}
var Ua = (n, e, t, r, s) => s.isOnAll ? !1 : !t && s.isOnTouch ? !(e || n) : (t ? r.isOnBlur : s.isOnBlur) ? !n : (t ? r.isOnChange : s.isOnChange) ? n : !0, Za = (n, e) => !xn(S(n, e)).length && oe(n, e);
const Ba = {
  mode: Ne.onSubmit,
  reValidateMode: Ne.onChange,
  shouldFocusError: !0
};
function qa(n = {}) {
  let e = {
    ...Ba,
    ...n
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ce(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, r = {}, s = se(e.defaultValues) || se(e.values) ? be(e.defaultValues || e.values) || {} : {}, a = e.shouldUnregister ? {} : be(s), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, i = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, l = 0;
  const f = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: Rn(),
    array: Rn(),
    state: Rn()
  }, u = yr(e.mode), g = yr(e.reValidateMode), m = e.criteriaMode === Ne.all, b = (h) => (p) => {
    clearTimeout(l), l = setTimeout(h, p);
  }, y = async (h) => {
    if (!e.disabled && (f.isValid || h)) {
      const p = e.resolver ? ve((await D()).errors) : await W(r, !0);
      p !== t.isValid && d.state.next({
        isValid: p
      });
    }
  }, R = (h, p) => {
    !e.disabled && (f.isValidating || f.validatingFields) && ((h || Array.from(i.mount)).forEach((_) => {
      _ && (p ? Y(t.validatingFields, _, p) : oe(t.validatingFields, _));
    }), d.state.next({
      validatingFields: t.validatingFields,
      isValidating: !ve(t.validatingFields)
    }));
  }, k = (h, p = [], _, T, $ = !0, x = !0) => {
    if (T && _ && !e.disabled) {
      if (o.action = !0, x && Array.isArray(S(r, h))) {
        const A = _(S(r, h), T.argA, T.argB);
        $ && Y(r, h, A);
      }
      if (x && Array.isArray(S(t.errors, h))) {
        const A = _(S(t.errors, h), T.argA, T.argB);
        $ && Y(t.errors, h, A), Za(t.errors, h);
      }
      if (f.touchedFields && x && Array.isArray(S(t.touchedFields, h))) {
        const A = _(S(t.touchedFields, h), T.argA, T.argB);
        $ && Y(t.touchedFields, h, A);
      }
      f.dirtyFields && (t.dirtyFields = kt(s, a)), d.state.next({
        name: h,
        isDirty: z(h, p),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Y(a, h, p);
  }, F = (h, p) => {
    Y(t.errors, h, p), d.state.next({
      errors: t.errors
    });
  }, J = (h) => {
    t.errors = h, d.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, H = (h, p, _, T) => {
    const $ = S(r, h);
    if ($) {
      const x = S(a, h, ne(_) ? S(s, h) : _);
      ne(x) || T && T.defaultChecked || p ? Y(a, h, p ? x : zn($._f)) : B(h, x), o.mount && y();
    }
  }, ce = (h, p, _, T, $) => {
    let x = !1, A = !1;
    const M = {
      name: h
    };
    if (!e.disabled) {
      const ie = !!(S(r, h) && S(r, h)._f && S(r, h)._f.disabled);
      if (!_ || T) {
        f.isDirty && (A = t.isDirty, t.isDirty = M.isDirty = z(), x = A !== M.isDirty);
        const le = ie || Ge(S(s, h), p);
        A = !!(!ie && S(t.dirtyFields, h)), le || ie ? oe(t.dirtyFields, h) : Y(t.dirtyFields, h, !0), M.dirtyFields = t.dirtyFields, x = x || f.dirtyFields && A !== !le;
      }
      if (_) {
        const le = S(t.touchedFields, h);
        le || (Y(t.touchedFields, h, _), M.touchedFields = t.touchedFields, x = x || f.touchedFields && le !== _);
      }
      x && $ && d.state.next(M);
    }
    return x ? M : {};
  }, X = (h, p, _, T) => {
    const $ = S(t.errors, h), x = f.isValid && ke(p) && t.isValid !== p;
    if (e.delayError && _ ? (c = b(() => F(h, _)), c(e.delayError)) : (clearTimeout(l), c = null, _ ? Y(t.errors, h, _) : oe(t.errors, h)), (_ ? !Ge($, _) : $) || !ve(T) || x) {
      const A = {
        ...T,
        ...x && ke(p) ? { isValid: p } : {},
        errors: t.errors,
        name: h
      };
      t = {
        ...t,
        ...A
      }, d.state.next(A);
    }
  }, D = async (h) => {
    R(h, !0);
    const p = await e.resolver(a, e.context, Va(h || i.mount, r, e.criteriaMode, e.shouldUseNativeValidation));
    return R(h), p;
  }, ee = async (h) => {
    const { errors: p } = await D(h);
    if (h)
      for (const _ of h) {
        const T = S(p, _);
        T ? Y(t.errors, _, T) : oe(t.errors, _);
      }
    else
      t.errors = p;
    return p;
  }, W = async (h, p, _ = {
    valid: !0
  }) => {
    for (const T in h) {
      const $ = h[T];
      if ($) {
        const { _f: x, ...A } = $;
        if (x) {
          const M = i.array.has(x.name), ie = $._f && Fa($._f);
          ie && f.validatingFields && R([T], !0);
          const le = await Nr($, i.disabled, a, m, e.shouldUseNativeValidation && !p, M);
          if (ie && f.validatingFields && R([T]), le[x.name] && (_.valid = !1, p))
            break;
          !p && (S(le, x.name) ? M ? La(t.errors, le, x.name) : Y(t.errors, x.name, le[x.name]) : oe(t.errors, x.name));
        }
        !ve(A) && await W(A, p, _);
      }
    }
    return _.valid;
  }, G = () => {
    for (const h of i.unMount) {
      const p = S(r, h);
      p && (p._f.refs ? p._f.refs.every((_) => !An(_)) : !An(p._f.ref)) && On(h);
    }
    i.unMount = /* @__PURE__ */ new Set();
  }, z = (h, p) => !e.disabled && (h && p && Y(a, h, p), !Ge(qe(), s)), Z = (h, p, _) => ms(h, i, {
    ...o.mount ? a : ne(p) ? s : Re(h) ? { [h]: p } : p
  }, _, p), K = (h) => xn(S(o.mount ? a : s, h, e.shouldUnregister ? S(s, h, []) : [])), B = (h, p, _ = {}) => {
    const T = S(r, h);
    let $ = p;
    if (T) {
      const x = T._f;
      x && (!x.disabled && Y(a, h, ks(p, x)), $ = rn(x.ref) && pe(p) ? "" : p, ys(x.ref) ? [...x.ref.options].forEach((A) => A.selected = $.includes(A.value)) : x.refs ? Ht(x.ref) ? x.refs.length > 1 ? x.refs.forEach((A) => (!A.defaultChecked || !A.disabled) && (A.checked = Array.isArray($) ? !!$.find((M) => M === A.value) : $ === A.value)) : x.refs[0] && (x.refs[0].checked = !!$) : x.refs.forEach((A) => A.checked = A.value === $) : nr(x.ref) ? x.ref.value = "" : (x.ref.value = $, x.ref.type || d.values.next({
        name: h,
        values: { ...a }
      })));
    }
    (_.shouldDirty || _.shouldTouch) && ce(h, $, _.shouldTouch, _.shouldDirty, !0), _.shouldValidate && ye(h);
  }, ue = (h, p, _) => {
    for (const T in p) {
      const $ = p[T], x = `${h}.${T}`, A = S(r, x);
      (i.array.has(h) || se($) || A && !A._f) && !Xe($) ? ue(x, $, _) : B(x, $, _);
    }
  }, de = (h, p, _ = {}) => {
    const T = S(r, h), $ = i.array.has(h), x = be(p);
    Y(a, h, x), $ ? (d.array.next({
      name: h,
      values: { ...a }
    }), (f.isDirty || f.dirtyFields) && _.shouldDirty && d.state.next({
      name: h,
      dirtyFields: kt(s, a),
      isDirty: z(h, x)
    })) : T && !T._f && !pe(x) ? ue(h, x, _) : B(h, x, _), wr(h, i) && d.state.next({ ...t }), d.values.next({
      name: o.mount ? h : void 0,
      values: { ...a }
    });
  }, Be = async (h) => {
    o.mount = !0;
    const p = h.target;
    let _ = p.name, T = !0;
    const $ = S(r, _), x = () => p.type ? zn($._f) : us(h), A = (M) => {
      T = Number.isNaN(M) || Xe(M) && isNaN(M.getTime()) || Ge(M, S(a, _, M));
    };
    if ($) {
      let M, ie;
      const le = x(), He = h.type === nn.BLUR || h.type === nn.FOCUS_OUT, xa = !Ma($._f) && !e.resolver && !S(t.errors, _) && !$._f.deps || Ua(He, S(t.touchedFields, _), t.isSubmitted, g, u), En = wr(_, i, He);
      Y(a, _, le), He ? ($._f.onBlur && $._f.onBlur(h), c && c(0)) : $._f.onChange && $._f.onChange(h);
      const Cn = ce(_, le, He, !1), ka = !ve(Cn) || En;
      if (!He && d.values.next({
        name: _,
        type: h.type,
        values: { ...a }
      }), xa)
        return f.isValid && (e.mode === "onBlur" && He ? y() : He || y()), ka && d.state.next({ name: _, ...En ? {} : Cn });
      if (!He && En && d.state.next({ ...t }), e.resolver) {
        const { errors: mr } = await D([_]);
        if (A(le), T) {
          const Sa = Tr(t.errors, r, _), _r = Tr(mr, r, Sa.name || _);
          M = _r.error, _ = _r.name, ie = ve(mr);
        }
      } else
        R([_], !0), M = (await Nr($, i.disabled, a, m, e.shouldUseNativeValidation))[_], R([_]), A(le), T && (M ? ie = !1 : f.isValid && (ie = await W(r, !0)));
      T && ($._f.deps && ye($._f.deps), X(_, ie, M, Cn));
    }
  }, ae = (h, p) => {
    if (S(t.errors, p) && h.focus)
      return h.focus(), 1;
  }, ye = async (h, p = {}) => {
    let _, T;
    const $ = Tt(h);
    if (e.resolver) {
      const x = await ee(ne(h) ? h : $);
      _ = ve(x), T = h ? !$.some((A) => S(x, A)) : _;
    } else h ? (T = (await Promise.all($.map(async (x) => {
      const A = S(r, x);
      return await W(A && A._f ? { [x]: A } : A);
    }))).every(Boolean), !(!T && !t.isValid) && y()) : T = _ = await W(r);
    return d.state.next({
      ...!Re(h) || f.isValid && _ !== t.isValid ? {} : { name: h },
      ...e.resolver || !h ? { isValid: _ } : {},
      errors: t.errors
    }), p.shouldFocus && !T && Et(r, ae, h ? $ : i.mount), T;
  }, qe = (h) => {
    const p = {
      ...o.mount ? a : s
    };
    return ne(h) ? p : Re(h) ? S(p, h) : h.map((_) => S(p, _));
  }, xt = (h, p) => ({
    invalid: !!S((p || t).errors, h),
    isDirty: !!S((p || t).dirtyFields, h),
    error: S((p || t).errors, h),
    isValidating: !!S(t.validatingFields, h),
    isTouched: !!S((p || t).touchedFields, h)
  }), Kt = (h) => {
    h && Tt(h).forEach((p) => oe(t.errors, p)), d.state.next({
      errors: h ? t.errors : {}
    });
  }, ur = (h, p, _) => {
    const T = (S(r, h, { _f: {} })._f || {}).ref, $ = S(t.errors, h) || {}, { ref: x, message: A, type: M, ...ie } = $;
    Y(t.errors, h, {
      ...ie,
      ...p,
      ref: T
    }), d.state.next({
      name: h,
      errors: t.errors,
      isValid: !1
    }), _ && _.shouldFocus && T && T.focus && T.focus();
  }, va = (h, p) => Ce(h) ? d.values.subscribe({
    next: (_) => h(Z(void 0, p), _)
  }) : Z(h, p, !0), On = (h, p = {}) => {
    for (const _ of h ? Tt(h) : i.mount)
      i.mount.delete(_), i.array.delete(_), p.keepValue || (oe(r, _), oe(a, _)), !p.keepError && oe(t.errors, _), !p.keepDirty && oe(t.dirtyFields, _), !p.keepTouched && oe(t.touchedFields, _), !p.keepIsValidating && oe(t.validatingFields, _), !e.shouldUnregister && !p.keepDefaultValue && oe(s, _);
    d.values.next({
      values: { ...a }
    }), d.state.next({
      ...t,
      ...p.keepDirty ? { isDirty: z() } : {}
    }), !p.keepIsValid && y();
  }, dr = ({ disabled: h, name: p, field: _, fields: T }) => {
    (ke(h) && o.mount || h || i.disabled.has(p)) && (h ? i.disabled.add(p) : i.disabled.delete(p), ce(p, zn(_ ? _._f : S(T, p)._f), !1, !1, !0));
  }, Tn = (h, p = {}) => {
    let _ = S(r, h);
    const T = ke(p.disabled) || ke(e.disabled);
    return Y(r, h, {
      ..._ || {},
      _f: {
        ..._ && _._f ? _._f : { ref: { name: h } },
        name: h,
        mount: !0,
        ...p
      }
    }), i.mount.add(h), _ ? dr({
      field: _,
      disabled: ke(p.disabled) ? p.disabled : e.disabled,
      name: h
    }) : H(h, !0, p.value), {
      ...T ? { disabled: p.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!p.required,
        min: St(p.min),
        max: St(p.max),
        minLength: St(p.minLength),
        maxLength: St(p.maxLength),
        pattern: St(p.pattern)
      } : {},
      name: h,
      onChange: Be,
      onBlur: Be,
      ref: ($) => {
        if ($) {
          Tn(h, p), _ = S(r, h);
          const x = ne($.value) && $.querySelectorAll && $.querySelectorAll("input,select,textarea")[0] || $, A = Ia(x), M = _._f.refs || [];
          if (A ? M.find((ie) => ie === x) : x === _._f.ref)
            return;
          Y(r, h, {
            _f: {
              ..._._f,
              ...A ? {
                refs: [
                  ...M.filter(An),
                  x,
                  ...Array.isArray(S(s, h)) ? [{}] : []
                ],
                ref: { type: x.type, name: h }
              } : { ref: x }
            }
          }), H(h, !1, void 0, x);
        } else
          _ = S(r, h, {}), _._f && (_._f.mount = !1), (e.shouldUnregister || p.shouldUnregister) && !(ds(i.array, h) && o.action) && i.unMount.add(h);
      }
    };
  }, fr = () => e.shouldFocusError && Et(r, ae, i.mount), ya = (h) => {
    ke(h) && (d.state.next({ disabled: h }), Et(r, (p, _) => {
      const T = S(r, _);
      T && (p.disabled = T._f.disabled || h, Array.isArray(T._f.refs) && T._f.refs.forEach(($) => {
        $.disabled = T._f.disabled || h;
      }));
    }, 0, !1));
  }, hr = (h, p) => async (_) => {
    let T;
    _ && (_.preventDefault && _.preventDefault(), _.persist && _.persist());
    let $ = be(a);
    if (i.disabled.size)
      for (const x of i.disabled)
        Y($, x, void 0);
    if (d.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: x, values: A } = await D();
      t.errors = x, $ = A;
    } else
      await W(r);
    if (oe(t.errors, "root"), ve(t.errors)) {
      d.state.next({
        errors: {}
      });
      try {
        await h($, _);
      } catch (x) {
        T = x;
      }
    } else
      p && await p({ ...t.errors }, _), fr(), setTimeout(fr);
    if (d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ve(t.errors) && !T,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), T)
      throw T;
  }, wa = (h, p = {}) => {
    S(r, h) && (ne(p.defaultValue) ? de(h, be(S(s, h))) : (de(h, p.defaultValue), Y(s, h, be(p.defaultValue))), p.keepTouched || oe(t.touchedFields, h), p.keepDirty || (oe(t.dirtyFields, h), t.isDirty = p.defaultValue ? z(h, be(S(s, h))) : z()), p.keepError || (oe(t.errors, h), f.isValid && y()), d.state.next({ ...t }));
  }, gr = (h, p = {}) => {
    const _ = h ? be(h) : s, T = be(_), $ = ve(h), x = $ ? s : T;
    if (p.keepDefaultValues || (s = _), !p.keepValues) {
      if (p.keepDirtyValues) {
        const A = /* @__PURE__ */ new Set([
          ...i.mount,
          ...Object.keys(kt(s, a))
        ]);
        for (const M of Array.from(A))
          S(t.dirtyFields, M) ? Y(x, M, S(a, M)) : de(M, S(x, M));
      } else {
        if (Qn && ne(h))
          for (const A of i.mount) {
            const M = S(r, A);
            if (M && M._f) {
              const ie = Array.isArray(M._f.refs) ? M._f.refs[0] : M._f.ref;
              if (rn(ie)) {
                const le = ie.closest("form");
                if (le) {
                  le.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      a = e.shouldUnregister ? p.keepDefaultValues ? be(s) : {} : be(x), d.array.next({
        values: { ...x }
      }), d.values.next({
        values: { ...x }
      });
    }
    i = {
      mount: p.keepDirtyValues ? i.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !f.isValid || !!p.keepIsValid || !!p.keepDirtyValues, o.watch = !!e.shouldUnregister, d.state.next({
      submitCount: p.keepSubmitCount ? t.submitCount : 0,
      isDirty: $ ? !1 : p.keepDirty ? t.isDirty : !!(p.keepDefaultValues && !Ge(h, s)),
      isSubmitted: p.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: $ ? {} : p.keepDirtyValues ? p.keepDefaultValues && a ? kt(s, a) : t.dirtyFields : p.keepDefaultValues && h ? kt(s, h) : p.keepDirty ? t.dirtyFields : {},
      touchedFields: p.keepTouched ? t.touchedFields : {},
      errors: p.keepErrors ? t.errors : {},
      isSubmitSuccessful: p.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, pr = (h, p) => gr(Ce(h) ? h(a) : h, p);
  return {
    control: {
      register: Tn,
      unregister: On,
      getFieldState: xt,
      handleSubmit: hr,
      setError: ur,
      _executeSchema: D,
      _getWatch: Z,
      _getDirty: z,
      _updateValid: y,
      _removeUnmounted: G,
      _updateFieldArray: k,
      _updateDisabledField: dr,
      _getFieldArray: K,
      _reset: gr,
      _resetDefaultValues: () => Ce(e.defaultValues) && e.defaultValues().then((h) => {
        pr(h, e.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (h) => {
        t = {
          ...t,
          ...h
        };
      },
      _disableForm: ya,
      _subjects: d,
      _proxyFormState: f,
      _setErrors: J,
      get _fields() {
        return r;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return o;
      },
      set _state(h) {
        o = h;
      },
      get _defaultValues() {
        return s;
      },
      get _names() {
        return i;
      },
      set _names(h) {
        i = h;
      },
      get _formState() {
        return t;
      },
      set _formState(h) {
        t = h;
      },
      get _options() {
        return e;
      },
      set _options(h) {
        e = {
          ...e,
          ...h
        };
      }
    },
    trigger: ye,
    register: Tn,
    handleSubmit: hr,
    watch: va,
    setValue: de,
    getValues: qe,
    reset: pr,
    resetField: wa,
    clearErrors: Kt,
    unregister: On,
    setError: ur,
    setFocus: (h, p = {}) => {
      const _ = S(r, h), T = _ && _._f;
      if (T) {
        const $ = T.refs ? T.refs[0] : T.ref;
        $.focus && ($.focus(), p.shouldSelect && Ce($.select) && $.select());
      }
    },
    getFieldState: xt
  };
}
function Ha(n = {}) {
  const e = U.useRef(void 0), t = U.useRef(void 0), [r, s] = U.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ce(n.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1,
    defaultValues: Ce(n.defaultValues) ? void 0 : n.defaultValues
  });
  e.current || (e.current = {
    ...qa(n),
    formState: r
  });
  const a = e.current.control;
  return a._options = n, tr({
    subject: a._subjects.state,
    next: (o) => {
      gs(o, a._proxyFormState, a._updateFormState, !0) && s({ ...a._formState });
    }
  }), U.useEffect(() => a._disableForm(n.disabled), [a, n.disabled]), U.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const o = a._getDirty();
      o !== r.isDirty && a._subjects.state.next({
        isDirty: o
      });
    }
  }, [a, r.isDirty]), U.useEffect(() => {
    n.values && !Ge(n.values, t.current) ? (a._reset(n.values, a._options.resetOptions), t.current = n.values, s((o) => ({ ...o }))) : a._resetDefaultValues();
  }, [n.values, a]), U.useEffect(() => {
    n.errors && a._setErrors(n.errors);
  }, [n.errors, a]), U.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), U.useEffect(() => {
    n.shouldUnregister && a._subjects.values.next({
      values: a._getWatch()
    });
  }, [n.shouldUnregister, a]), e.current.formState = hs(r, a), e.current;
}
const Wa = (n, e, t, r) => {
  var a, o, i, c;
  const s = [t, {
    code: e,
    ...r || {}
  }];
  if ((o = (a = n == null ? void 0 : n.services) == null ? void 0 : a.logger) != null && o.forward)
    return n.services.logger.forward(s, "warn", "react-i18next::", !0);
  et(s[0]) && (s[0] = `react-i18next:: ${s[0]}`), (c = (i = n == null ? void 0 : n.services) == null ? void 0 : i.logger) != null && c.warn ? n.services.logger.warn(...s) : console != null && console.warn && console.warn(...s);
}, Er = {}, Fn = (n, e, t, r) => {
  et(t) && Er[t] || (et(t) && (Er[t] = /* @__PURE__ */ new Date()), Wa(n, e, t, r));
}, Ss = (n, e) => () => {
  if (n.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        n.off("initialized", t);
      }, 0), e();
    };
    n.on("initialized", t);
  }
}, Mn = (n, e, t) => {
  n.loadNamespaces(e, Ss(n, t));
}, Cr = (n, e, t, r) => {
  if (et(t) && (t = [t]), n.options.preload && n.options.preload.indexOf(e) > -1) return Mn(n, t, r);
  t.forEach((s) => {
    n.options.ns.indexOf(s) < 0 && n.options.ns.push(s);
  }), n.loadLanguages(e, Ss(n, r));
}, Ga = (n, e, t = {}) => !e.languages || !e.languages.length ? (Fn(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(n, {
  lng: t.lng,
  precheck: (r, s) => {
    var a;
    if (((a = t.bindI18n) == null ? void 0 : a.indexOf("languageChanging")) > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !s(r.isLanguageChangingTo, n)) return !1;
  }
}), et = (n) => typeof n == "string", Ka = (n) => typeof n == "object" && n !== null, Ya = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Ja = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Qa = (n) => Ja[n], Xa = (n) => n.replace(Ya, Qa);
let eo = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Xa
};
const to = () => eo;
let no;
const ro = () => no, $s = ss();
class so {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const ao = (n, e) => {
  const t = os();
  return pt(() => {
    t.current = n;
  }, [n, e]), t.current;
}, Ns = (n, e, t, r) => n.getFixedT(e, t, r), oo = (n, e, t, r) => $a(Ns(n, e, t, r), [n, e, t, r]), sr = (n, e = {}) => {
  var J, H, ce, X;
  const {
    i18n: t
  } = e, {
    i18n: r,
    defaultNS: s
  } = as($s) || {}, a = t || r || ro();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new so()), !a) {
    Fn(a, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const D = (W, G) => et(G) ? G : Ka(G) && et(G.defaultValue) ? G.defaultValue : Array.isArray(W) ? W[W.length - 1] : W, ee = [D, {}, !1];
    return ee.t = D, ee.i18n = {}, ee.ready = !1, ee;
  }
  (J = a.options.react) != null && J.wait && Fn(a, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = {
    ...to(),
    ...a.options.react,
    ...e
  }, {
    useSuspense: i,
    keyPrefix: c
  } = o;
  let l = n || s || ((H = a.options) == null ? void 0 : H.defaultNS);
  l = et(l) ? [l] : l || ["translation"], (X = (ce = a.reportNamespaces).addUsedNamespaces) == null || X.call(ce, l);
  const f = (a.isInitialized || a.initializedStoreOnce) && l.every((D) => Ga(D, a, o)), d = oo(a, e.lng || null, o.nsMode === "fallback" ? l : l[0], c), u = () => d, g = () => Ns(a, e.lng || null, o.nsMode === "fallback" ? l : l[0], c), [m, b] = Me(u);
  let y = l.join();
  e.lng && (y = `${e.lng}${y}`);
  const R = ao(y), k = os(!0);
  pt(() => {
    const {
      bindI18n: D,
      bindI18nStore: ee
    } = o;
    k.current = !0, !f && !i && (e.lng ? Cr(a, e.lng, l, () => {
      k.current && b(g);
    }) : Mn(a, l, () => {
      k.current && b(g);
    })), f && R && R !== y && k.current && b(g);
    const W = () => {
      k.current && b(g);
    };
    return D && (a == null || a.on(D, W)), ee && (a == null || a.store.on(ee, W)), () => {
      k.current = !1, a && (D == null || D.split(" ").forEach((G) => a.off(G, W))), ee && a && ee.split(" ").forEach((G) => a.store.off(G, W));
    };
  }, [a, y]), pt(() => {
    k.current && f && b(u);
  }, [a, c, f]);
  const F = [m, a, f];
  if (F.t = m, F.i18n = a, F.ready = f, f || !f && !i) return F;
  throw new Promise((D) => {
    e.lng ? Cr(a, e.lng, l, () => D()) : Mn(a, l, () => D());
  });
};
function io({
  i18n: n,
  defaultNS: e,
  children: t
}) {
  const r = is(() => ({
    i18n: n,
    defaultNS: e
  }), [n, e]);
  return Na($s.Provider, {
    value: r
  }, t);
}
function Os(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var s = n.length;
    for (e = 0; e < s; e++) n[e] && (t = Os(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function re() {
  for (var n, e, t = 0, r = "", s = arguments.length; t < s; t++) (n = arguments[t]) && (e = Os(n)) && (r && (r += " "), r += e);
  return r;
}
const lo = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook-path1",
  "icon_facebook-path2",
  "icon_gmail-path1",
  "icon_gmail-path2",
  "icon_gmail-path3",
  "icon_gmail-path4",
  "icon_gmail-path5",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], co = lo.map((n) => ({
  name: n,
  class: `icon-${n}`
})), uo = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, fo = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function ho(n = 0) {
  const e = [];
  for (let t = 0; t < n; t++)
    e[t] = `path${t + 1}`;
  return e.map((t) => /* @__PURE__ */ v("span", { className: t }, t));
}
const mt = Jn(
  ({ name: n, size: e = "medium", color: t = "base", className: r = "", ...s }, a) => {
    const o = co.find((c) => c.name === n), i = re("icon", `ds-${o == null ? void 0 : o.class}`, fo[e], uo[t], r);
    return /* @__PURE__ */ v("i", { className: i, ...s, ref: a, children: ho(o == null ? void 0 : o.transform) });
  }
);
mt.displayName = "Icon";
const go = "_loader_1ksyv_29", po = "_circle_1ksyv_41", ot = {
  loader: go,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: po,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, mo = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, _o = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function bo({ onDark: n, size: e = "medium", color: t = "primary", className: r }) {
  return /* @__PURE__ */ Q(
    "svg",
    {
      className: re(
        ot.loader,
        ot[mo[e]],
        ot[_o[t]],
        n && ot["on-dark"],
        r
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: ot.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ Q(
          "circle",
          {
            className: ot["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const vo = "_button_z1os6_29", yo = "_disabled_z1os6_43", wo = "_loader_z1os6_263", Pe = {
  button: vo,
  disabled: yo,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: wo,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, _t = Jn(
  ({
    color: n = "primary",
    text: e,
    size: t = "regular",
    isFullWidth: r = !1,
    icon: s,
    iconPosition: a = "left",
    iconSize: o,
    onClick: i,
    children: c,
    disabled: l,
    type: f = "button",
    className: d = "",
    href: u,
    isLoading: g,
    isContrasted: m = !1,
    ...b
  }, y) => {
    const R = re(
      Pe.button,
      Pe[xo[n]],
      Pe[ko[t]],
      r && Pe["is-full-width"],
      l && Pe.disabled,
      a === "right" && Pe["has-icon-right"],
      m && Pe["is-contrasted"],
      g && Pe["is-loading"],
      d
    ), k = /* @__PURE__ */ Q(rs, { children: [
      g && /* @__PURE__ */ v(bo, { className: Pe.loader, onDark: !0, size: "small" }),
      s && a === "left" && /* @__PURE__ */ v(mt, { color: "inherit", size: o, name: s }),
      c ?? e,
      s && a === "right" && /* @__PURE__ */ v(mt, { color: "inherit", size: o, name: s })
    ] }), F = {
      onClick: i,
      className: R,
      ...b
    };
    return u ? /* @__PURE__ */ v("a", { href: l ? void 0 : u, ref: y, ...F, children: k }) : /* @__PURE__ */ v(
      "button",
      {
        ref: y,
        disabled: g || l,
        type: f,
        ...F,
        children: k
      }
    );
  }
);
_t.displayName = "Button";
const xo = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, ko = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, So = "_buttons_1obz3_29", Rr = {
  buttons: So,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, Ts = ({ children: n, flexGrowButtons: e }) => /* @__PURE__ */ v("div", { className: re(Rr.buttons, e && Rr["flex-grow-buttons"]), children: n }), Ar = {
  MOBILE: 640,
  TABLET: 768
}, $o = "_text_1dzaz_29", it = {
  text: $o,
  "is-small": "_is-small_1dzaz_34",
  "is-ellipsis": "_is-ellipsis_1dzaz_38",
  "color-primary": "_color-primary_1dzaz_43",
  "color-secondary": "_color-secondary_1dzaz_46",
  "color-tertiary": "_color-tertiary_1dzaz_49",
  "color-eco-green": "_color-eco-green_1dzaz_52",
  "color-success": "_color-success_1dzaz_55",
  "color-error": "_color-error_1dzaz_58",
  "color-inverted": "_color-inverted_1dzaz_61",
  "color-warning": "_color-warning_1dzaz_64",
  "is-bold": "_is-bold_1dzaz_67",
  "size-xs": "_size-xs_1dzaz_70",
  "size-sm": "_size-sm_1dzaz_73",
  "size-base": "_size-base_1dzaz_76",
  "size-lg": "_size-lg_1dzaz_79",
  "size-xl": "_size-xl_1dzaz_82",
  "dialog-overlay-show": "_dialog-overlay-show_1dzaz_1",
  "dialog-content-show": "_dialog-content-show_1dzaz_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1dzaz_1"
};
function Rt({
  children: n,
  dangerouslySetInnerHTML: e,
  isSmall: t,
  ellipsis: r,
  isSpan: s,
  className: a = "",
  color: o,
  isBold: i,
  size: c,
  title: l,
  ...f
}) {
  const d = re(
    it.text,
    t && it["is-small"],
    r && it["is-ellipsis"],
    o && it[`color-${o}`],
    i && it["is-bold"],
    c && it[`size-${c}`],
    a
  ), u = s ? "span" : "div";
  return e ? /* @__PURE__ */ v(u, { className: d, dangerouslySetInnerHTML: e, ...f, title: l }) : /* @__PURE__ */ v(u, { className: d, ...f, children: n });
}
const No = "_title_1tre1_29", Oo = "_subtitle_1tre1_92", lt = {
  "title-container": "_title-container_1tre1_29",
  "color-inverted": "_color-inverted_1tre1_29",
  "is-primary": "_is-primary_1tre1_32",
  "is-secondary": "_is-secondary_1tre1_35",
  "is-tertiary": "_is-tertiary_1tre1_38",
  "is-success": "_is-success_1tre1_41",
  "is-error": "_is-error_1tre1_44",
  "is-eco-green": "_is-eco-green_1tre1_47",
  title: No,
  "is-1": "_is-1_1tre1_59",
  "is-impact": "_is-impact_1tre1_68",
  "is-2": "_is-2_1tre1_72",
  "is-3": "_is-3_1tre1_82",
  subtitle: Oo,
  "dialog-overlay-show": "_dialog-overlay-show_1tre1_1",
  "dialog-content-show": "_dialog-content-show_1tre1_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tre1_1"
}, To = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function Es({
  color: n = "default",
  children: e,
  level: t = 3,
  hasHeaderTag: r = !1,
  isImpact: s,
  subtitle: a,
  className: o = "",
  title: i,
  ...c
}) {
  const l = `h${t}`, f = `${r ? l : "p"}`, d = re(lt.title, lt[`is-${t}`], s && lt["is-impact"], o);
  return /* @__PURE__ */ Q("div", { className: re(lt["title-container"], lt[To[n]]), children: [
    /* @__PURE__ */ v(f, { className: d, ...c, title: i, children: e }),
    a && /* @__PURE__ */ v("p", { className: re(lt.subtitle), children: a })
  ] });
}
function Ue(n, e, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(r) {
    if (n == null || n(r), t === !1 || !r.defaultPrevented)
      return e == null ? void 0 : e(r);
  };
}
var on = globalThis != null && globalThis.document ? O.useLayoutEffect : () => {
};
function ar(n) {
  const e = O.useRef(n);
  return O.useEffect(() => {
    e.current = n;
  }), O.useMemo(() => (...t) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...t);
  }, []);
}
function Cs({
  prop: n,
  defaultProp: e,
  onChange: t = () => {
  }
}) {
  const [r, s] = Eo({ defaultProp: e, onChange: t }), a = n !== void 0, o = a ? n : r, i = ar(t), c = O.useCallback(
    (l) => {
      if (a) {
        const f = typeof l == "function" ? l(n) : l;
        f !== n && i(f);
      } else
        s(l);
    },
    [a, n, s, i]
  );
  return [o, c];
}
function Eo({
  defaultProp: n,
  onChange: e
}) {
  const t = O.useState(n), [r] = t, s = O.useRef(r), a = ar(e);
  return O.useEffect(() => {
    s.current !== r && (a(r), s.current = r);
  }, [r, s, a]), t;
}
var Yt = { exports: {} }, fe = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function Co() {
  if (zr) return fe;
  zr = 1;
  var n = U;
  function e(c) {
    var l = "https://react.dev/errors/" + c;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var f = 2; f < arguments.length; f++)
        l += "&args[]=" + encodeURIComponent(arguments[f]);
    }
    return "Minified React error #" + c + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function t() {
  }
  var r = {
    d: {
      f: t,
      r: function() {
        throw Error(e(522));
      },
      D: t,
      C: t,
      L: t,
      m: t,
      X: t,
      S: t,
      M: t
    },
    p: 0,
    findDOMNode: null
  }, s = Symbol.for("react.portal");
  function a(c, l, f) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: s,
      key: d == null ? null : "" + d,
      children: c,
      containerInfo: l,
      implementation: f
    };
  }
  var o = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function i(c, l) {
    if (c === "font") return "";
    if (typeof l == "string")
      return l === "use-credentials" ? l : "";
  }
  return fe.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, fe.createPortal = function(c, l) {
    var f = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11)
      throw Error(e(299));
    return a(c, l, null, f);
  }, fe.flushSync = function(c) {
    var l = o.T, f = r.p;
    try {
      if (o.T = null, r.p = 2, c) return c();
    } finally {
      o.T = l, r.p = f, r.d.f();
    }
  }, fe.preconnect = function(c, l) {
    typeof c == "string" && (l ? (l = l.crossOrigin, l = typeof l == "string" ? l === "use-credentials" ? l : "" : void 0) : l = null, r.d.C(c, l));
  }, fe.prefetchDNS = function(c) {
    typeof c == "string" && r.d.D(c);
  }, fe.preinit = function(c, l) {
    if (typeof c == "string" && l && typeof l.as == "string") {
      var f = l.as, d = i(f, l.crossOrigin), u = typeof l.integrity == "string" ? l.integrity : void 0, g = typeof l.fetchPriority == "string" ? l.fetchPriority : void 0;
      f === "style" ? r.d.S(
        c,
        typeof l.precedence == "string" ? l.precedence : void 0,
        {
          crossOrigin: d,
          integrity: u,
          fetchPriority: g
        }
      ) : f === "script" && r.d.X(c, {
        crossOrigin: d,
        integrity: u,
        fetchPriority: g,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0
      });
    }
  }, fe.preinitModule = function(c, l) {
    if (typeof c == "string")
      if (typeof l == "object" && l !== null) {
        if (l.as == null || l.as === "script") {
          var f = i(
            l.as,
            l.crossOrigin
          );
          r.d.M(c, {
            crossOrigin: f,
            integrity: typeof l.integrity == "string" ? l.integrity : void 0,
            nonce: typeof l.nonce == "string" ? l.nonce : void 0
          });
        }
      } else l == null && r.d.M(c);
  }, fe.preload = function(c, l) {
    if (typeof c == "string" && typeof l == "object" && l !== null && typeof l.as == "string") {
      var f = l.as, d = i(f, l.crossOrigin);
      r.d.L(c, f, {
        crossOrigin: d,
        integrity: typeof l.integrity == "string" ? l.integrity : void 0,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0,
        type: typeof l.type == "string" ? l.type : void 0,
        fetchPriority: typeof l.fetchPriority == "string" ? l.fetchPriority : void 0,
        referrerPolicy: typeof l.referrerPolicy == "string" ? l.referrerPolicy : void 0,
        imageSrcSet: typeof l.imageSrcSet == "string" ? l.imageSrcSet : void 0,
        imageSizes: typeof l.imageSizes == "string" ? l.imageSizes : void 0,
        media: typeof l.media == "string" ? l.media : void 0
      });
    }
  }, fe.preloadModule = function(c, l) {
    if (typeof c == "string")
      if (l) {
        var f = i(l.as, l.crossOrigin);
        r.d.m(c, {
          as: typeof l.as == "string" && l.as !== "script" ? l.as : void 0,
          crossOrigin: f,
          integrity: typeof l.integrity == "string" ? l.integrity : void 0
        });
      } else r.d.m(c);
  }, fe.requestFormReset = function(c) {
    r.d.r(c);
  }, fe.unstable_batchedUpdates = function(c, l) {
    return c(l);
  }, fe.useFormState = function(c, l, f) {
    return o.H.useFormState(c, l, f);
  }, fe.useFormStatus = function() {
    return o.H.useHostTransitionStatus();
  }, fe.version = "19.0.0", fe;
}
var he = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Ro() {
  return Dr || (Dr = 1, process.env.NODE_ENV !== "production" && function() {
    function n() {
    }
    function e(d) {
      return "" + d;
    }
    function t(d, u, g) {
      var m = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        e(m);
        var b = !1;
      } catch {
        b = !0;
      }
      return b && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && m[Symbol.toStringTag] || m.constructor.name || "Object"
      ), e(m)), {
        $$typeof: l,
        key: m == null ? null : "" + m,
        children: d,
        containerInfo: u,
        implementation: g
      };
    }
    function r(d, u) {
      if (d === "font") return "";
      if (typeof u == "string")
        return u === "use-credentials" ? u : "";
    }
    function s(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : 'something with type "' + typeof d + '"';
    }
    function a(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : typeof d == "string" ? JSON.stringify(d) : typeof d == "number" ? "`" + d + "`" : 'something with type "' + typeof d + '"';
    }
    function o() {
      var d = f.H;
      return d === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = U, c = {
      d: {
        f: n,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: n,
        C: n,
        L: n,
        m: n,
        X: n,
        S: n,
        M: n
      },
      p: 0,
      findDOMNode: null
    }, l = Symbol.for("react.portal"), f = i.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), he.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = c, he.createPortal = function(d, u) {
      var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return t(d, u, null, g);
    }, he.flushSync = function(d) {
      var u = f.T, g = c.p;
      try {
        if (f.T = null, c.p = 2, d)
          return d();
      } finally {
        f.T = u, c.p = g, c.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, he.preconnect = function(d, u) {
      typeof d == "string" && d ? u != null && typeof u != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        a(u)
      ) : u != null && typeof u.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        s(u.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        s(d)
      ), typeof d == "string" && (u ? (u = u.crossOrigin, u = typeof u == "string" ? u === "use-credentials" ? u : "" : void 0) : u = null, c.d.C(d, u));
    }, he.prefetchDNS = function(d) {
      if (typeof d != "string" || !d)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          s(d)
        );
      else if (1 < arguments.length) {
        var u = arguments[1];
        typeof u == "object" && u.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(u)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(u)
        );
      }
      typeof d == "string" && c.d.D(d);
    }, he.preinit = function(d, u) {
      if (typeof d == "string" && d ? u == null || typeof u != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        a(u)
      ) : u.as !== "style" && u.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        a(u.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        s(d)
      ), typeof d == "string" && u && typeof u.as == "string") {
        var g = u.as, m = r(g, u.crossOrigin), b = typeof u.integrity == "string" ? u.integrity : void 0, y = typeof u.fetchPriority == "string" ? u.fetchPriority : void 0;
        g === "style" ? c.d.S(
          d,
          typeof u.precedence == "string" ? u.precedence : void 0,
          {
            crossOrigin: m,
            integrity: b,
            fetchPriority: y
          }
        ) : g === "script" && c.d.X(d, {
          crossOrigin: m,
          integrity: b,
          fetchPriority: y,
          nonce: typeof u.nonce == "string" ? u.nonce : void 0
        });
      }
    }, he.preinitModule = function(d, u) {
      var g = "";
      if (typeof d == "string" && d || (g += " The `href` argument encountered was " + s(d) + "."), u !== void 0 && typeof u != "object" ? g += " The `options` argument encountered was " + s(u) + "." : u && "as" in u && u.as !== "script" && (g += " The `as` option encountered was " + a(u.as) + "."), g)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          g
        );
      else
        switch (g = u && typeof u.as == "string" ? u.as : "script", g) {
          case "script":
            break;
          default:
            g = a(g), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              g,
              d
            );
        }
      typeof d == "string" && (typeof u == "object" && u !== null ? (u.as == null || u.as === "script") && (g = r(
        u.as,
        u.crossOrigin
      ), c.d.M(d, {
        crossOrigin: g,
        integrity: typeof u.integrity == "string" ? u.integrity : void 0,
        nonce: typeof u.nonce == "string" ? u.nonce : void 0
      })) : u == null && c.d.M(d));
    }, he.preload = function(d, u) {
      var g = "";
      if (typeof d == "string" && d || (g += " The `href` argument encountered was " + s(d) + "."), u == null || typeof u != "object" ? g += " The `options` argument encountered was " + s(u) + "." : typeof u.as == "string" && u.as || (g += " The `as` option encountered was " + s(u.as) + "."), g && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        g
      ), typeof d == "string" && typeof u == "object" && u !== null && typeof u.as == "string") {
        g = u.as;
        var m = r(
          g,
          u.crossOrigin
        );
        c.d.L(d, g, {
          crossOrigin: m,
          integrity: typeof u.integrity == "string" ? u.integrity : void 0,
          nonce: typeof u.nonce == "string" ? u.nonce : void 0,
          type: typeof u.type == "string" ? u.type : void 0,
          fetchPriority: typeof u.fetchPriority == "string" ? u.fetchPriority : void 0,
          referrerPolicy: typeof u.referrerPolicy == "string" ? u.referrerPolicy : void 0,
          imageSrcSet: typeof u.imageSrcSet == "string" ? u.imageSrcSet : void 0,
          imageSizes: typeof u.imageSizes == "string" ? u.imageSizes : void 0,
          media: typeof u.media == "string" ? u.media : void 0
        });
      }
    }, he.preloadModule = function(d, u) {
      var g = "";
      typeof d == "string" && d || (g += " The `href` argument encountered was " + s(d) + "."), u !== void 0 && typeof u != "object" ? g += " The `options` argument encountered was " + s(u) + "." : u && "as" in u && typeof u.as != "string" && (g += " The `as` option encountered was " + s(u.as) + "."), g && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        g
      ), typeof d == "string" && (u ? (g = r(
        u.as,
        u.crossOrigin
      ), c.d.m(d, {
        as: typeof u.as == "string" && u.as !== "script" ? u.as : void 0,
        crossOrigin: g,
        integrity: typeof u.integrity == "string" ? u.integrity : void 0
      })) : c.d.m(d));
    }, he.requestFormReset = function(d) {
      c.d.r(d);
    }, he.unstable_batchedUpdates = function(d, u) {
      return d(u);
    }, he.useFormState = function(d, u, g) {
      return o().useFormState(d, u, g);
    }, he.useFormStatus = function() {
      return o().useHostTransitionStatus();
    }, he.version = "19.0.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), he;
}
var Lr;
function Ao() {
  if (Lr) return Yt.exports;
  Lr = 1;
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (n(), Yt.exports = Co()) : Yt.exports = Ro(), Yt.exports;
}
Ao();
function jr(n, e) {
  if (typeof n == "function")
    return n(e);
  n != null && (n.current = e);
}
function Rs(...n) {
  return (e) => {
    let t = !1;
    const r = n.map((s) => {
      const a = jr(s, e);
      return !t && typeof a == "function" && (t = !0), a;
    });
    if (t)
      return () => {
        for (let s = 0; s < r.length; s++) {
          const a = r[s];
          typeof a == "function" ? a() : jr(n[s], null);
        }
      };
  };
}
function bt(...n) {
  return O.useCallback(Rs(...n), n);
}
function kn(n, e = []) {
  let t = [];
  function r(a, o) {
    const i = O.createContext(o), c = t.length;
    t = [...t, o];
    const l = (d) => {
      var u;
      const { scope: g, children: m, ...b } = d, y = ((u = g == null ? void 0 : g[n]) == null ? void 0 : u[c]) || i, R = O.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ v(y.Provider, { value: R, children: m });
    };
    l.displayName = a + "Provider";
    function f(d, u) {
      var g;
      const m = ((g = u == null ? void 0 : u[n]) == null ? void 0 : g[c]) || i, b = O.useContext(m);
      if (b) return b;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return [l, f];
  }
  const s = () => {
    const a = t.map((o) => O.createContext(o));
    return function(o) {
      const i = (o == null ? void 0 : o[n]) || a;
      return O.useMemo(
        () => ({ [`__scope${n}`]: { ...o, [n]: i } }),
        [o, i]
      );
    };
  };
  return s.scopeName = n, [r, zo(s, ...e)];
}
function zo(...n) {
  const e = n[0];
  if (n.length === 1) return e;
  const t = () => {
    const r = n.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(s) {
      const a = r.reduce((o, { useScope: i, scopeName: c }) => {
        const l = i(s)[`__scope${c}`];
        return { ...o, ...l };
      }, {});
      return O.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return t.scopeName = e.scopeName, t;
}
var ln = O.forwardRef((n, e) => {
  const { children: t, ...r } = n, s = O.Children.toArray(t), a = s.find(Lo);
  if (a) {
    const o = a.props.children, i = s.map((c) => c === a ? O.Children.count(o) > 1 ? O.Children.only(null) : O.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ v(Un, { ...r, ref: e, children: O.isValidElement(o) ? O.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ v(Un, { ...r, ref: e, children: t });
});
ln.displayName = "Slot";
var Un = O.forwardRef((n, e) => {
  const { children: t, ...r } = n;
  if (O.isValidElement(t)) {
    const s = Po(t), a = jo(r, t.props);
    return t.type !== O.Fragment && (a.ref = e ? Rs(e, s) : s), O.cloneElement(t, a);
  }
  return O.Children.count(t) > 1 ? O.Children.only(null) : null;
});
Un.displayName = "SlotClone";
var Do = ({ children: n }) => /* @__PURE__ */ v(rs, { children: n });
function Lo(n) {
  return O.isValidElement(n) && n.type === Do;
}
function jo(n, e) {
  const t = { ...e };
  for (const r in e) {
    const s = n[r], a = e[r];
    /^on[A-Z]/.test(r) ? s && a ? t[r] = (...o) => {
      a(...o), s(...o);
    } : s && (t[r] = s) : r === "style" ? t[r] = { ...s, ...a } : r === "className" && (t[r] = [s, a].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function Po(n) {
  var e, t;
  let r = (e = Object.getOwnPropertyDescriptor(n.props, "ref")) == null ? void 0 : e.get, s = r && "isReactWarning" in r && r.isReactWarning;
  return s ? n.ref : (r = (t = Object.getOwnPropertyDescriptor(n, "ref")) == null ? void 0 : t.get, s = r && "isReactWarning" in r && r.isReactWarning, s ? n.props.ref : n.props.ref || n.ref);
}
var Io = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Wt = Io.reduce((n, e) => {
  const t = O.forwardRef((r, s) => {
    const { asChild: a, ...o } = r, i = a ? ln : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(i, { ...o, ref: s });
  });
  return t.displayName = `Primitive.${e}`, { ...n, [e]: t };
}, {}), Vo = O.createContext(void 0);
function As(n) {
  const e = O.useContext(Vo);
  return n || e || "ltr";
}
function Fo(n) {
  const e = n + "CollectionProvider", [t, r] = kn(e), [s, a] = t(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (g) => {
    const { scope: m, children: b } = g, y = U.useRef(null), R = U.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(s, { scope: m, itemMap: R, collectionRef: y, children: b });
  };
  o.displayName = e;
  const i = n + "CollectionSlot", c = U.forwardRef(
    (g, m) => {
      const { scope: b, children: y } = g, R = a(i, b), k = bt(m, R.collectionRef);
      return /* @__PURE__ */ v(ln, { ref: k, children: y });
    }
  );
  c.displayName = i;
  const l = n + "CollectionItemSlot", f = "data-radix-collection-item", d = U.forwardRef(
    (g, m) => {
      const { scope: b, children: y, ...R } = g, k = U.useRef(null), F = bt(m, k), J = a(l, b);
      return U.useEffect(() => (J.itemMap.set(k, { ref: k, ...R }), () => void J.itemMap.delete(k))), /* @__PURE__ */ v(ln, { [f]: "", ref: F, children: y });
    }
  );
  d.displayName = l;
  function u(g) {
    const m = a(n + "CollectionConsumer", g);
    return U.useCallback(() => {
      const b = m.collectionRef.current;
      if (!b) return [];
      const y = Array.from(b.querySelectorAll(`[${f}]`));
      return Array.from(m.itemMap.values()).sort(
        (R, k) => y.indexOf(R.ref.current) - y.indexOf(k.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: o, Slot: c, ItemSlot: d },
    u,
    r
  ];
}
var Mo = O.useId || (() => {
}), Uo = 0;
function Zo(n) {
  const [e, t] = O.useState(Mo());
  return on(() => {
    t((r) => r ?? String(Uo++));
  }, [n]), e ? `radix-${e}` : "";
}
var Dn = "rovingFocusGroup.onEntryFocus", Bo = { bubbles: !1, cancelable: !0 }, Sn = "RovingFocusGroup", [Zn, zs, qo] = Fo(Sn), [Ho, Ds] = kn(
  Sn,
  [qo]
), [Wo, Go] = Ho(Sn), Ls = O.forwardRef(
  (n, e) => /* @__PURE__ */ v(Zn.Provider, { scope: n.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Zn.Slot, { scope: n.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Ko, { ...n, ref: e }) }) })
);
Ls.displayName = Sn;
var Ko = O.forwardRef((n, e) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: r,
    loop: s = !1,
    dir: a,
    currentTabStopId: o,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: f = !1,
    ...d
  } = n, u = O.useRef(null), g = bt(e, u), m = As(a), [b = null, y] = Cs({
    prop: o,
    defaultProp: i,
    onChange: c
  }), [R, k] = O.useState(!1), F = ar(l), J = zs(t), H = O.useRef(!1), [ce, X] = O.useState(0);
  return O.useEffect(() => {
    const D = u.current;
    if (D)
      return D.addEventListener(Dn, F), () => D.removeEventListener(Dn, F);
  }, [F]), /* @__PURE__ */ v(
    Wo,
    {
      scope: t,
      orientation: r,
      dir: m,
      loop: s,
      currentTabStopId: b,
      onItemFocus: O.useCallback(
        (D) => y(D),
        [y]
      ),
      onItemShiftTab: O.useCallback(() => k(!0), []),
      onFocusableItemAdd: O.useCallback(
        () => X((D) => D + 1),
        []
      ),
      onFocusableItemRemove: O.useCallback(
        () => X((D) => D - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        Wt.div,
        {
          tabIndex: R || ce === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: g,
          style: { outline: "none", ...n.style },
          onMouseDown: Ue(n.onMouseDown, () => {
            H.current = !0;
          }),
          onFocus: Ue(n.onFocus, (D) => {
            const ee = !H.current;
            if (D.target === D.currentTarget && ee && !R) {
              const W = new CustomEvent(Dn, Bo);
              if (D.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const G = J().filter((B) => B.focusable), z = G.find((B) => B.active), Z = G.find((B) => B.id === b), K = [z, Z, ...G].filter(
                  Boolean
                ).map((B) => B.ref.current);
                Is(K, f);
              }
            }
            H.current = !1;
          }),
          onBlur: Ue(n.onBlur, () => k(!1))
        }
      )
    }
  );
}), js = "RovingFocusGroupItem", Ps = O.forwardRef(
  (n, e) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: r = !0,
      active: s = !1,
      tabStopId: a,
      ...o
    } = n, i = Zo(), c = a || i, l = Go(js, t), f = l.currentTabStopId === c, d = zs(t), { onFocusableItemAdd: u, onFocusableItemRemove: g } = l;
    return O.useEffect(() => {
      if (r)
        return u(), () => g();
    }, [r, u, g]), /* @__PURE__ */ v(
      Zn.ItemSlot,
      {
        scope: t,
        id: c,
        focusable: r,
        active: s,
        children: /* @__PURE__ */ v(
          Wt.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": l.orientation,
            ...o,
            ref: e,
            onMouseDown: Ue(n.onMouseDown, (m) => {
              r ? l.onItemFocus(c) : m.preventDefault();
            }),
            onFocus: Ue(n.onFocus, () => l.onItemFocus(c)),
            onKeyDown: Ue(n.onKeyDown, (m) => {
              if (m.key === "Tab" && m.shiftKey) {
                l.onItemShiftTab();
                return;
              }
              if (m.target !== m.currentTarget) return;
              const b = Qo(m, l.orientation, l.dir);
              if (b !== void 0) {
                if (m.metaKey || m.ctrlKey || m.altKey || m.shiftKey) return;
                m.preventDefault();
                let y = d().filter((R) => R.focusable).map((R) => R.ref.current);
                if (b === "last") y.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && y.reverse();
                  const R = y.indexOf(m.currentTarget);
                  y = l.loop ? Xo(y, R + 1) : y.slice(R + 1);
                }
                setTimeout(() => Is(y));
              }
            })
          }
        )
      }
    );
  }
);
Ps.displayName = js;
var Yo = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Jo(n, e) {
  return e !== "rtl" ? n : n === "ArrowLeft" ? "ArrowRight" : n === "ArrowRight" ? "ArrowLeft" : n;
}
function Qo(n, e, t) {
  const r = Jo(n.key, t);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Yo[r];
}
function Is(n, e = !1) {
  const t = document.activeElement;
  for (const r of n)
    if (r === t || (r.focus({ preventScroll: e }), document.activeElement !== t)) return;
}
function Xo(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
var ei = Ls, ti = Ps;
function ni(n) {
  const [e, t] = O.useState(void 0);
  return on(() => {
    if (n) {
      t({ width: n.offsetWidth, height: n.offsetHeight });
      const r = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const a = s[0];
        let o, i;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          o = l.inlineSize, i = l.blockSize;
        } else
          o = n.offsetWidth, i = n.offsetHeight;
        t({ width: o, height: i });
      });
      return r.observe(n, { box: "border-box" }), () => r.unobserve(n);
    } else
      t(void 0);
  }, [n]), e;
}
function ri(n) {
  const e = O.useRef({ value: n, previous: n });
  return O.useMemo(() => (e.current.value !== n && (e.current.previous = e.current.value, e.current.value = n), e.current.previous), [n]);
}
function si(n, e) {
  return O.useReducer((t, r) => e[t][r] ?? t, n);
}
var Vs = (n) => {
  const { present: e, children: t } = n, r = ai(e), s = typeof t == "function" ? t({ present: r.isPresent }) : O.Children.only(t), a = bt(r.ref, oi(s));
  return typeof t == "function" || r.isPresent ? O.cloneElement(s, { ref: a }) : null;
};
Vs.displayName = "Presence";
function ai(n) {
  const [e, t] = O.useState(), r = O.useRef({}), s = O.useRef(n), a = O.useRef("none"), o = n ? "mounted" : "unmounted", [i, c] = si(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return O.useEffect(() => {
    const l = Jt(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), on(() => {
    const l = r.current, f = s.current;
    if (f !== n) {
      const d = a.current, u = Jt(l);
      n ? c("MOUNT") : u === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(f && d !== u ? "ANIMATION_OUT" : "UNMOUNT"), s.current = n;
    }
  }, [n, c]), on(() => {
    if (e) {
      let l;
      const f = e.ownerDocument.defaultView ?? window, d = (g) => {
        const m = Jt(r.current).includes(g.animationName);
        if (g.target === e && m && (c("ANIMATION_END"), !s.current)) {
          const b = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = b);
          });
        }
      }, u = (g) => {
        g.target === e && (a.current = Jt(r.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        f.clearTimeout(l), e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: O.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), t(l);
    }, [])
  };
}
function Jt(n) {
  return (n == null ? void 0 : n.animationName) || "none";
}
function oi(n) {
  var e, t;
  let r = (e = Object.getOwnPropertyDescriptor(n.props, "ref")) == null ? void 0 : e.get, s = r && "isReactWarning" in r && r.isReactWarning;
  return s ? n.ref : (r = (t = Object.getOwnPropertyDescriptor(n, "ref")) == null ? void 0 : t.get, s = r && "isReactWarning" in r && r.isReactWarning, s ? n.props.ref : n.props.ref || n.ref);
}
var or = "Radio", [ii, Fs] = kn(or), [li, ci] = ii(or), Ms = O.forwardRef(
  (n, e) => {
    const {
      __scopeRadio: t,
      name: r,
      checked: s = !1,
      required: a,
      disabled: o,
      value: i = "on",
      onCheck: c,
      form: l,
      ...f
    } = n, [d, u] = O.useState(null), g = bt(e, (y) => u(y)), m = O.useRef(!1), b = d ? l || !!d.closest("form") : !0;
    return /* @__PURE__ */ Q(li, { scope: t, checked: s, disabled: o, children: [
      /* @__PURE__ */ v(
        Wt.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": s,
          "data-state": Bs(s),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: i,
          ...f,
          ref: g,
          onClick: Ue(n.onClick, (y) => {
            s || c == null || c(), b && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        ui,
        {
          control: d,
          bubbles: !m.current,
          name: r,
          value: i,
          checked: s,
          required: a,
          disabled: o,
          form: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Ms.displayName = or;
var Us = "RadioIndicator", Zs = O.forwardRef(
  (n, e) => {
    const { __scopeRadio: t, forceMount: r, ...s } = n, a = ci(Us, t);
    return /* @__PURE__ */ v(Vs, { present: r || a.checked, children: /* @__PURE__ */ v(
      Wt.span,
      {
        "data-state": Bs(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...s,
        ref: e
      }
    ) });
  }
);
Zs.displayName = Us;
var ui = (n) => {
  const { control: e, checked: t, bubbles: r = !0, ...s } = n, a = O.useRef(null), o = ri(t), i = ni(e);
  return O.useEffect(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (o !== t && f) {
      const d = new Event("click", { bubbles: r });
      f.call(c, t), c.dispatchEvent(d);
    }
  }, [o, t, r]), /* @__PURE__ */ v(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: t,
      ...s,
      tabIndex: -1,
      ref: a,
      style: {
        ...n.style,
        ...i,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Bs(n) {
  return n ? "checked" : "unchecked";
}
var di = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ir = "RadioGroup", [fi, Xg] = kn(ir, [
  Ds,
  Fs
]), qs = Ds(), Hs = Fs(), [hi, gi] = fi(ir), Ws = O.forwardRef(
  (n, e) => {
    const {
      __scopeRadioGroup: t,
      name: r,
      defaultValue: s,
      value: a,
      required: o = !1,
      disabled: i = !1,
      orientation: c,
      dir: l,
      loop: f = !0,
      onValueChange: d,
      ...u
    } = n, g = qs(t), m = As(l), [b, y] = Cs({
      prop: a,
      defaultProp: s,
      onChange: d
    });
    return /* @__PURE__ */ v(
      hi,
      {
        scope: t,
        name: r,
        required: o,
        disabled: i,
        value: b,
        onValueChange: y,
        children: /* @__PURE__ */ v(
          ei,
          {
            asChild: !0,
            ...g,
            orientation: c,
            dir: m,
            loop: f,
            children: /* @__PURE__ */ v(
              Wt.div,
              {
                role: "radiogroup",
                "aria-required": o,
                "aria-orientation": c,
                "data-disabled": i ? "" : void 0,
                dir: m,
                ...u,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
Ws.displayName = ir;
var Gs = "RadioGroupItem", Ks = O.forwardRef(
  (n, e) => {
    const { __scopeRadioGroup: t, disabled: r, ...s } = n, a = gi(Gs, t), o = a.disabled || r, i = qs(t), c = Hs(t), l = O.useRef(null), f = bt(e, l), d = a.value === s.value, u = O.useRef(!1);
    return O.useEffect(() => {
      const g = (b) => {
        di.includes(b.key) && (u.current = !0);
      }, m = () => u.current = !1;
      return document.addEventListener("keydown", g), document.addEventListener("keyup", m), () => {
        document.removeEventListener("keydown", g), document.removeEventListener("keyup", m);
      };
    }, []), /* @__PURE__ */ v(
      ti,
      {
        asChild: !0,
        ...i,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ v(
          Ms,
          {
            disabled: o,
            required: a.required,
            checked: d,
            ...c,
            ...s,
            name: a.name,
            ref: f,
            onCheck: () => a.onValueChange(s.value),
            onKeyDown: Ue((g) => {
              g.key === "Enter" && g.preventDefault();
            }),
            onFocus: Ue(s.onFocus, () => {
              var g;
              u.current && ((g = l.current) == null || g.click());
            })
          }
        )
      }
    );
  }
);
Ks.displayName = Gs;
var pi = "RadioGroupIndicator", Ys = O.forwardRef(
  (n, e) => {
    const { __scopeRadioGroup: t, ...r } = n, s = Hs(t);
    return /* @__PURE__ */ v(Zs, { ...s, ...r, ref: e });
  }
);
Ys.displayName = pi;
var mi = Ws, _i = Ks, bi = Ys;
const vi = "_indicator_o29me_51", yi = "_label_o29me_66", Qt = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: vi,
  label: yi
};
function wi({ value: n, id: e, label: t, description: r }) {
  return /* @__PURE__ */ Q("div", { className: Qt["radio-item"], children: [
    /* @__PURE__ */ v(_i, { value: n, id: e, className: Qt["radio-button"], "aria-label": t, children: /* @__PURE__ */ v(bi, { className: Qt.indicator }) }),
    /* @__PURE__ */ Q("label", { htmlFor: e, className: Qt.label, children: [
      t,
      r && /* @__PURE__ */ v("p", { children: r })
    ] })
  ] });
}
const xi = "_title_ej2xw_37", ki = "_text_ej2xw_41", ct = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: xi,
  text: ki,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function Bn({
  children: n,
  defaultValue: e,
  label: t,
  helperContent: r,
  errorMessage: s,
  disabled: a,
  onChange: o,
  onBlur: i,
  value: c,
  name: l
}) {
  const f = !!s, d = !!(t ?? r);
  return /* @__PURE__ */ Q(
    mi,
    {
      name: l,
      onValueChange: o,
      defaultValue: e,
      className: re(ct["radio-group"], s && ct["has-error"]),
      disabled: a,
      onBlur: i,
      value: c,
      children: [
        d && /* @__PURE__ */ Q("div", { className: ct["group-label"], children: [
          t && /* @__PURE__ */ v("label", { className: ct.title, children: t }),
          r && /* @__PURE__ */ v("p", { className: ct.text, children: r })
        ] }),
        n,
        f && /* @__PURE__ */ Q("p", { className: ct["error-message"], children: [
          /* @__PURE__ */ v(mt, { name: "error-warning-fill", color: "error" }),
          s
        ] })
      ]
    }
  );
}
Bn.Item = wi;
const Si = "_flex_k8zg6_29", $i = "_wrap_k8zg6_67", Ni = "_nowrap_k8zg6_70", Se = {
  flex: Si,
  "flex-row": "_flex-row_k8zg6_34",
  "flex-column": "_flex-column_k8zg6_37",
  "justify-start": "_justify-start_k8zg6_40",
  "justify-end": "_justify-end_k8zg6_43",
  "justify-center": "_justify-center_k8zg6_46",
  "justify-space-between": "_justify-space-between_k8zg6_49",
  "justify-space-around": "_justify-space-around_k8zg6_52",
  "align-start": "_align-start_k8zg6_55",
  "align-end": "_align-end_k8zg6_58",
  "align-center": "_align-center_k8zg6_61",
  "align-stretch": "_align-stretch_k8zg6_64",
  wrap: $i,
  nowrap: Ni,
  "wrap-reverse": "_wrap-reverse_k8zg6_73",
  "is-full-width": "_is-full-width_k8zg6_79",
  "is-full-height": "_is-full-height_k8zg6_82",
  "flex-grow": "_flex-grow_k8zg6_85",
  "hide-on-mobile": "_hide-on-mobile_k8zg6_88",
  "gap-0": "_gap-0_k8zg6_96",
  "gap-1": "_gap-1_k8zg6_99",
  "gap-2": "_gap-2_k8zg6_102",
  "gap-3": "_gap-3_k8zg6_105",
  "gap-4": "_gap-4_k8zg6_108",
  "gap-5": "_gap-5_k8zg6_111",
  "gap-6": "_gap-6_k8zg6_114",
  "gap-7": "_gap-7_k8zg6_117",
  "gap-8": "_gap-8_k8zg6_120",
  "gap-9": "_gap-9_k8zg6_123",
  "gap-10": "_gap-10_k8zg6_126",
  "gap-11": "_gap-11_k8zg6_129",
  "gap-12": "_gap-12_k8zg6_132",
  "gap-14": "_gap-14_k8zg6_135",
  "gap-16": "_gap-16_k8zg6_138",
  "gap-18": "_gap-18_k8zg6_141",
  "gap-20": "_gap-20_k8zg6_144",
  "gap-24": "_gap-24_k8zg6_147",
  "gap-28": "_gap-28_k8zg6_150",
  "gap-32": "_gap-32_k8zg6_153",
  "gap-36": "_gap-36_k8zg6_156",
  "gap-40": "_gap-40_k8zg6_159",
  "gap-44": "_gap-44_k8zg6_162",
  "gap-48": "_gap-48_k8zg6_165",
  "gap-52": "_gap-52_k8zg6_168",
  "gap-56": "_gap-56_k8zg6_171",
  "gap-60": "_gap-60_k8zg6_174",
  "gap-64": "_gap-64_k8zg6_177",
  "gap-72": "_gap-72_k8zg6_180",
  "gap-80": "_gap-80_k8zg6_183",
  "gap-96": "_gap-96_k8zg6_186",
  "no-margin": "_no-margin_k8zg6_189",
  "dialog-overlay-show": "_dialog-overlay-show_k8zg6_1",
  "dialog-content-show": "_dialog-content-show_k8zg6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k8zg6_1"
};
function Oi({
  children: n,
  direction: e = "row",
  justifyContent: t = "start",
  alignItems: r = "start",
  flexWrap: s = "wrap",
  className: a = "",
  isFullWidth: o = !1,
  isFullHeight: i = !1,
  gap: c,
  style: l,
  noMargin: f = !1,
  flexGrow: d = !1,
  hideOnMobile: u = !1,
  ...g
}) {
  const m = re(
    Se.flex,
    Se[`flex-${e}`],
    Se[`justify-${t}`],
    Se[`align-${r}`],
    Se[s],
    o && Se["is-full-width"],
    i && Se["is-full-height"],
    c && Se[`gap-${c}`],
    f && Se["no-margin"],
    d && Se["flex-grow"],
    u && Se["hide-on-mobile"],
    a
  );
  return /* @__PURE__ */ v("div", { className: m, ...g, style: l, children: n });
}
function Ti() {
  const [n, e] = Me({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return pt(() => {
    function t() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", t), t(), () => window.removeEventListener("resize", t);
  }, []), n;
}
function Ei() {
  const { width: n } = Ti();
  let e = "desktop";
  return n && n <= Ar.MOBILE ? e = "mobile" : n && n <= Ar.TABLET && (e = "tablet"), {
    currentWidth: n,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop"
  };
}
const Ci = 0;
function Ri(n, e, t, r, s, a) {
  const [o, i] = Me(!1), c = o ? t : r, [l, f] = Me(c ? c.length : Ci), [d, u] = Me(!1);
  return {
    valueCounter: l,
    isOnBlur: d,
    hasLabelOrHelperText: !!(n ?? e),
    handleBlur: () => {
      u(!0), a == null || a();
    },
    handleChange: (g) => {
      i(!0), f(g.target.value.length), s && s(g), u(!1);
    }
  };
}
const Ai = "_container_k248c_29", zi = "_filled_k248c_43", Di = "_error_k248c_46", Li = "_success_k248c_49", ji = "_counter_k248c_126", xe = {
  container: Ai,
  "group-label": "_group-label_k248c_34",
  filled: zi,
  error: Di,
  success: Li,
  "helper-text": "_helper-text_k248c_52",
  "container-counter-icon": "_container-counter-icon_k248c_105",
  "container-icon": "_container-icon_k248c_112",
  "icon-error-warning-fill": "_icon-error-warning-fill_k248c_117",
  counter: ji,
  "dialog-overlay-show": "_dialog-overlay-show_k248c_1",
  "dialog-content-show": "_dialog-content-show_k248c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k248c_1"
};
function Pi({
  id: n,
  disabled: e = !1,
  status: t,
  title: r,
  helperText: s,
  placeholder: a,
  maxLength: o,
  onChange: i,
  onBlur: c,
  message: l,
  value: f,
  defaultValue: d,
  name: u
}) {
  const {
    valueCounter: g,
    isOnBlur: m,
    handleBlur: b,
    handleChange: y,
    hasLabelOrHelperText: R
  } = Ri(r, s, f, d, i, c);
  return /* @__PURE__ */ Q("div", { className: xe.container, children: [
    R && /* @__PURE__ */ Q("div", { className: xe["group-label"], children: [
      r && /* @__PURE__ */ v(
        "label",
        {
          htmlFor: n,
          className: re(t && xe[t], (g > 0 && m || e) && xe.filled),
          children: r
        }
      ),
      s && /* @__PURE__ */ v("div", { className: xe["helper-text"], children: s })
    ] }),
    /* @__PURE__ */ v(
      "textarea",
      {
        id: n,
        name: u,
        "aria-label": "textarea",
        placeholder: a,
        onChange: y,
        className: re(t && xe[t]),
        value: f,
        defaultValue: d,
        disabled: e,
        onBlur: b
      }
    ),
    /* @__PURE__ */ Q("div", { className: xe["container-counter-icon"], children: [
      l && t && /* @__PURE__ */ Q("div", { className: xe["container-icon"], children: [
        /* @__PURE__ */ v(
          mt,
          {
            name: `${t === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: re(xe[t])
          }
        ),
        /* @__PURE__ */ v("span", { className: xe[t], children: l })
      ] }),
      o && /* @__PURE__ */ Q("div", { className: re(xe.counter, g > o && xe.error), children: [
        g,
        "/",
        o
      ] })
    ] })
  ] });
}
const Ln = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function Js({
  src: n,
  alt: e,
  width: t = "auto",
  borderRadius: r = "none",
  className: s = "",
  ...a
}) {
  const o = re(Ln.img, s, Ln[Ii[t]], Ln[Vi[r]]);
  return /* @__PURE__ */ v("img", { ...a, className: o, alt: e, src: n });
}
const Ii = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, Vi = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, Fi = "_callout_5p9zs_29", Mi = "_link_5p9zs_49", Xt = {
  callout: Fi,
  "is-small": "_is-small_5p9zs_44",
  link: Mi,
  "is-medium": "_is-medium_5p9zs_52",
  "is-info": "_is-info_5p9zs_55",
  "is-warning": "_is-warning_5p9zs_58",
  "is-success": "_is-success_5p9zs_61",
  "is-error": "_is-error_5p9zs_64",
  "is-neutral": "_is-neutral_5p9zs_67",
  "is-collection": "_is-collection_5p9zs_70",
  "content-container": "_content-container_5p9zs_76",
  "dialog-overlay-show": "_dialog-overlay-show_5p9zs_1",
  "dialog-content-show": "_dialog-content-show_5p9zs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_5p9zs_1"
}, Pr = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, Ui = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, Zi = {
  small: "is-small",
  medium: "is-medium"
};
function Bi({
  status: n = "info",
  size: e = "medium",
  children: t,
  hasIcon: r = !1,
  backgroundImage: s
}) {
  const a = re(Xt.callout, Xt[Ui[n]], Xt[Zi[e]]);
  return /* @__PURE__ */ Q("div", { className: a, children: [
    r && /* @__PURE__ */ v(mt, { name: Pr[n].name, color: Pr[n].color, size: "2xl" }),
    /* @__PURE__ */ v("div", { className: Xt["content-container"], children: t }),
    s && /* @__PURE__ */ v("img", { src: s, alt: "background" })
  ] });
}
const qi = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, Hi = ({ imageSrc: n, imageSrcMobile: e, imageSrcTablet: t, alt: r, className: s }) => {
  const { isMobile: a, isTablet: o } = Ei();
  let i = n;
  return a && e && (i = e), o && t && (i = t), /* @__PURE__ */ v("img", { className: s, src: i, alt: r });
}, Wi = "_banner_17hqf_29", Ie = {
  "banner-container": "_banner-container_17hqf_29",
  banner: Wi,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function Gi({ color: n, image: e, className: t, cta: r, title: s, description: a }) {
  const o = re(Ie.banner, Ie[qi[n]], t);
  return /* @__PURE__ */ v("div", { className: Ie["banner-container"], children: /* @__PURE__ */ Q("div", { className: o, children: [
    e && /* @__PURE__ */ v(Hi, { className: Ie["banner-image"], ...e }),
    /* @__PURE__ */ Q("div", { className: Ie["banner-content"], children: [
      /* @__PURE__ */ Q("div", { className: Ie["banner-text"], children: [
        /* @__PURE__ */ v(Rt, { isBold: !0, className: Ie.title, children: s }),
        /* @__PURE__ */ v(Rt, { className: Ie.description, children: a })
      ] }),
      r && /* @__PURE__ */ v(_t, { className: Ie["banner-cta"], color: r.color, onClick: r.onClick, children: r.text })
    ] })
  ] }) });
}
const Ki = "_columns_16c9q_29", Yi = "_column_16c9q_29", We = {
  columns: Ki,
  "reverse-on-mobile": "_reverse-on-mobile_16c9q_48",
  column: Yi,
  "center-content": "_center-content_16c9q_59",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_16c9q_70",
  "is-1": "_is-1_16c9q_89",
  "is-2": "_is-2_16c9q_93",
  "is-3": "_is-3_16c9q_97",
  "is-4": "_is-4_16c9q_101",
  "is-5": "_is-5_16c9q_105",
  "is-6": "_is-6_16c9q_109",
  "is-7": "_is-7_16c9q_113",
  "is-8": "_is-8_16c9q_117",
  "is-9": "_is-9_16c9q_121",
  "is-10": "_is-10_16c9q_125",
  "is-11": "_is-11_16c9q_129",
  "is-12": "_is-12_16c9q_133",
  "is-offset-1": "_is-offset-1_16c9q_137",
  "is-offset-2": "_is-offset-2_16c9q_140",
  "is-offset-3": "_is-offset-3_16c9q_143",
  "is-offset-4": "_is-offset-4_16c9q_146",
  "is-offset-5": "_is-offset-5_16c9q_149",
  "is-offset-6": "_is-offset-6_16c9q_152",
  "is-offset-7": "_is-offset-7_16c9q_155",
  "is-offset-8": "_is-offset-8_16c9q_158",
  "is-offset-9": "_is-offset-9_16c9q_161",
  "is-offset-10": "_is-offset-10_16c9q_164",
  "is-offset-11": "_is-offset-11_16c9q_167",
  "is-narrow": "_is-narrow_16c9q_170",
  "dialog-overlay-show": "_dialog-overlay-show_16c9q_1",
  "dialog-content-show": "_dialog-content-show_16c9q_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_16c9q_1"
};
function Qs({ children: n, className: e = "", reverseOnMobile: t = !1, ...r }) {
  const s = re(We.columns, t && We["reverse-on-mobile"], e);
  return /* @__PURE__ */ v("div", { className: s, ...r, children: n });
}
const Ji = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Qi = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function cn({
  size: n = "auto",
  offset: e = "auto",
  isNarrow: t = !1,
  centerContent: r,
  className: s = "",
  children: a,
  hiddenContentOnMobile: o = !1,
  ...i
}) {
  const c = re(
    We.column,
    We[Ji[n]],
    We[Qi[e]],
    t && We["is-narrow"],
    r && We["center-content"],
    o && We["hidden-content-on-mobile"],
    s
  );
  return /* @__PURE__ */ v("div", { className: c, ...i, children: a });
}
const Xi = "_container_ekulv_29", Ir = {
  container: Xi,
  "is-fluid": "_is-fluid_ekulv_45"
};
function el({ isFluid: n = !1, children: e, className: t = "", ...r }) {
  const s = re(Ir.container, n && Ir["is-fluid"], t);
  return /* @__PURE__ */ v("div", { className: s, ...r, children: e });
}
const tl = "_section_k7vxw_29", nl = "_content_k7vxw_32", $e = {
  section: tl,
  content: nl,
  "image-flex": "_image-flex_k7vxw_35",
  "image-container": "_image-container_k7vxw_43",
  "reverse-bg-color": "_reverse-bg-color_k7vxw_62",
  "image-reverse": "_image-reverse_k7vxw_68",
  "is-full-height": "_is-full-height_k7vxw_74",
  "center-content": "_center-content_k7vxw_77",
  "border-top": "_border-top_k7vxw_81",
  "border-bottom": "_border-bottom_k7vxw_84",
  "border-top-and-bottom": "_border-top-and-bottom_k7vxw_87",
  "is-primary": "_is-primary_k7vxw_91",
  "is-secondary": "_is-secondary_k7vxw_94",
  "is-tertiary": "_is-tertiary_k7vxw_97",
  "dialog-overlay-show": "_dialog-overlay-show_k7vxw_1",
  "dialog-content-show": "_dialog-content-show_k7vxw_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k7vxw_1"
}, rl = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, sl = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function al({
  children: n,
  className: e = "",
  color: t,
  border: r = "none",
  isFullHeight: s,
  centerContent: a,
  isSmallPadding: o,
  imageSrc: i,
  imagePosition: c,
  imageAlt: l,
  reverseBGColor: f,
  ...d
}) {
  const u = re(
    $e.section,
    e,
    t && $e[rl[t]],
    $e[sl[r]],
    s && $e["is-full-height"],
    a && $e["center-content"],
    o && $e["is-small-padding"],
    i && $e["image-flex"],
    c === "right" && $e["image-reverse"],
    f && $e["reverse-bg-color"]
  );
  return /* @__PURE__ */ Q("section", { ...d, className: u, children: [
    i && /* @__PURE__ */ v("div", { className: $e["image-container"], children: /* @__PURE__ */ v("img", { src: i, alt: l }) }),
    /* @__PURE__ */ v("div", { className: $e.content, children: n })
  ] });
}
function Xs(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var s = n.length;
    for (e = 0; e < s; e++) n[e] && (t = Xs(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function ol() {
  for (var n, e, t = 0, r = "", s = arguments.length; t < s; t++) (n = arguments[t]) && (e = Xs(n)) && (r && (r += " "), r += e);
  return r;
}
const il = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook-path1",
  "icon_facebook-path2",
  "icon_gmail-path1",
  "icon_gmail-path2",
  "icon_gmail-path3",
  "icon_gmail-path4",
  "icon_gmail-path5",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], ll = il.map((n) => ({
  name: n,
  class: `icon-${n}`
})), cl = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, ul = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function dl(n = 0) {
  const e = [];
  for (let t = 0; t < n; t++)
    e[t] = `path${t + 1}`;
  return e.map((t) => /* @__PURE__ */ v("span", { className: t }, t));
}
const fl = Jn(
  ({ name: n, size: e = "medium", color: t = "base", className: r = "", ...s }, a) => {
    const o = ll.find((c) => c.name === n), i = ol("icon", `ds-${o == null ? void 0 : o.class}`, ul[e], cl[t], r);
    return /* @__PURE__ */ v("i", { className: i, ...s, ref: a, children: dl(o == null ? void 0 : o.transform) });
  }
);
fl.displayName = "Icon";
const hl = ["en", "fr", "it"], ea = ss({
  locale: "en"
});
function gl({ children: n, ...e }) {
  return /* @__PURE__ */ v(ea.Provider, { value: e, children: n });
}
const pl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function ml(n) {
  return hl.includes(n) && !0;
}
function _l(n, e) {
  const t = pl.test(e);
  let r;
  return ml(n) || t ? r = `${e}` : r = `/${n}${e}`, { url: r };
}
function lr(n) {
  const { locale: e } = as(ea);
  return _l(e, n);
}
function bl() {
  const [n, e] = Me({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return pt(() => {
    function t() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", t), t(), () => window.removeEventListener("resize", t);
  }, []), n;
}
function ta() {
  const { width: n } = bl();
  let e = "desktop";
  return n && n <= br.MOBILE ? e = "mobile" : n && n <= br.TABLET && (e = "tablet"), {
    currentWidth: n,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop"
  };
}
const Vr = (n, e, t) => {
  if (n && "reportValidity" in n) {
    const r = S(t, e);
    n.setCustomValidity(r && r.message || ""), n.reportValidity();
  }
}, na = (n, e) => {
  for (const t in e.fields) {
    const r = e.fields[t];
    r && r.ref && "reportValidity" in r.ref ? Vr(r.ref, t, n) : r.refs && r.refs.forEach((s) => Vr(s, t, n));
  }
}, vl = (n, e) => {
  e.shouldUseNativeValidation && na(n, e);
  const t = {};
  for (const r in n) {
    const s = S(e.fields, r), a = Object.assign(n[r] || {}, { ref: s && s.ref });
    if (yl(e.names || Object.keys(n), r)) {
      const o = Object.assign({}, S(t, r));
      Y(o, "root", a), Y(t, r, o);
    } else Y(t, r, a);
  }
  return t;
}, yl = (n, e) => n.some((t) => t.startsWith(e + "."));
var wl = function(n, e) {
  for (var t = {}; n.length; ) {
    var r = n[0], s = r.code, a = r.message, o = r.path.join(".");
    if (!t[o]) if ("unionErrors" in r) {
      var i = r.unionErrors[0].errors[0];
      t[o] = { message: i.message, type: i.code };
    } else t[o] = { message: a, type: s };
    if ("unionErrors" in r && r.unionErrors.forEach(function(f) {
      return f.errors.forEach(function(d) {
        return n.push(d);
      });
    }), e) {
      var c = t[o].types, l = c && c[r.code];
      t[o] = _s(o, e, t, s, l ? [].concat(l, r.message) : r.message);
    }
    n.shift();
  }
  return t;
}, xl = function(n, e, t) {
  return t === void 0 && (t = {}), function(r, s, a) {
    try {
      return Promise.resolve(function(o, i) {
        try {
          var c = Promise.resolve(n[t.mode === "sync" ? "parse" : "parseAsync"](r, e)).then(function(l) {
            return a.shouldUseNativeValidation && na({}, a), { errors: {}, values: t.raw ? r : l };
          });
        } catch (l) {
          return i(l);
        }
        return c && c.then ? c.then(void 0, i) : c;
      }(0, function(o) {
        if (function(i) {
          return Array.isArray(i == null ? void 0 : i.errors);
        }(o)) return { values: {}, errors: vl(wl(o.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a) };
        throw o;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
}, q;
(function(n) {
  n.assertEqual = (s) => s;
  function e(s) {
  }
  n.assertIs = e;
  function t(s) {
    throw new Error();
  }
  n.assertNever = t, n.arrayToEnum = (s) => {
    const a = {};
    for (const o of s)
      a[o] = o;
    return a;
  }, n.getValidEnumValues = (s) => {
    const a = n.objectKeys(s).filter((i) => typeof s[s[i]] != "number"), o = {};
    for (const i of a)
      o[i] = s[i];
    return n.objectValues(o);
  }, n.objectValues = (s) => n.objectKeys(s).map(function(a) {
    return s[a];
  }), n.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const o in s)
      Object.prototype.hasOwnProperty.call(s, o) && a.push(o);
    return a;
  }, n.find = (s, a) => {
    for (const o of s)
      if (a(o))
        return o;
  }, n.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function r(s, a = " | ") {
    return s.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  n.joinValues = r, n.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(q || (q = {}));
var qn;
(function(n) {
  n.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(qn || (qn = {}));
const E = q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Fe = (n) => {
  switch (typeof n) {
    case "undefined":
      return E.undefined;
    case "string":
      return E.string;
    case "number":
      return isNaN(n) ? E.nan : E.number;
    case "boolean":
      return E.boolean;
    case "function":
      return E.function;
    case "bigint":
      return E.bigint;
    case "symbol":
      return E.symbol;
    case "object":
      return Array.isArray(n) ? E.array : n === null ? E.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? E.promise : typeof Map < "u" && n instanceof Map ? E.map : typeof Set < "u" && n instanceof Set ? E.set : typeof Date < "u" && n instanceof Date ? E.date : E.object;
    default:
      return E.unknown;
  }
}, w = q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), kl = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class we extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, s = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(s);
        else if (o.code === "invalid_return_type")
          s(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          s(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(t(o));
        else {
          let i = r, c = 0;
          for (; c < o.path.length; ) {
            const l = o.path[c];
            c === o.path.length - 1 ? (i[l] = i[l] || { _errors: [] }, i[l]._errors.push(t(o))) : i[l] = i[l] || { _errors: [] }, i = i[l], c++;
          }
        }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof we))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const s of this.issues)
      s.path.length > 0 ? (t[s.path[0]] = t[s.path[0]] || [], t[s.path[0]].push(e(s))) : r.push(e(s));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
we.create = (n) => new we(n);
const vt = (n, e) => {
  let t;
  switch (n.code) {
    case w.invalid_type:
      n.received === E.undefined ? t = "Required" : t = `Expected ${n.expected}, received ${n.received}`;
      break;
    case w.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(n.expected, q.jsonStringifyReplacer)}`;
      break;
    case w.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${q.joinValues(n.keys, ", ")}`;
      break;
    case w.invalid_union:
      t = "Invalid input";
      break;
    case w.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${q.joinValues(n.options)}`;
      break;
    case w.invalid_enum_value:
      t = `Invalid enum value. Expected ${q.joinValues(n.options)}, received '${n.received}'`;
      break;
    case w.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case w.invalid_return_type:
      t = "Invalid function return type";
      break;
    case w.invalid_date:
      t = "Invalid date";
      break;
    case w.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (t = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? t = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? t = `Invalid input: must end with "${n.validation.endsWith}"` : q.assertNever(n.validation) : n.validation !== "regex" ? t = `Invalid ${n.validation}` : t = "Invalid";
      break;
    case w.too_small:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : t = "Invalid input";
      break;
    case w.too_big:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? t = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : t = "Invalid input";
      break;
    case w.custom:
      t = "Invalid input";
      break;
    case w.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case w.not_multiple_of:
      t = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case w.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, q.assertNever(n);
  }
  return { message: t };
};
let ra = vt;
function Sl(n) {
  ra = n;
}
function un() {
  return ra;
}
const dn = (n) => {
  const { data: e, path: t, errorMaps: r, issueData: s } = n, a = [...t, ...s.path || []], o = {
    ...s,
    path: a
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: a,
      message: s.message
    };
  let i = "";
  const c = r.filter((l) => !!l).slice().reverse();
  for (const l of c)
    i = l(o, { data: e, defaultError: i }).message;
  return {
    ...s,
    path: a,
    message: i
  };
}, $l = [];
function N(n, e) {
  const t = un(), r = dn({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      // contextual error map is first priority
      n.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === vt ? void 0 : vt
      // then global default map
    ].filter((s) => !!s)
  });
  n.common.issues.push(r);
}
class ge {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const s of t) {
      if (s.status === "aborted")
        return j;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const s of t) {
      const a = await s.key, o = await s.value;
      r.push({
        key: a,
        value: o
      });
    }
    return ge.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const s of t) {
      const { key: a, value: o } = s;
      if (a.status === "aborted" || o.status === "aborted")
        return j;
      a.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || s.alwaysSet) && (r[a.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const j = Object.freeze({
  status: "aborted"
}), ht = (n) => ({ status: "dirty", value: n }), me = (n) => ({ status: "valid", value: n }), Hn = (n) => n.status === "aborted", Wn = (n) => n.status === "dirty", nt = (n) => n.status === "valid", At = (n) => typeof Promise < "u" && n instanceof Promise;
function fn(n, e, t, r) {
  if (typeof e == "function" ? n !== e || !0 : !e.has(n)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(n);
}
function sa(n, e, t, r, s) {
  if (typeof e == "function" ? n !== e || !0 : !e.has(n)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(n, t), t;
}
var C;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(C || (C = {}));
var Nt, Ot;
class De {
  constructor(e, t, r, s) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Fr = (n, e) => {
  if (nt(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new we(n.common.issues);
      return this._error = t, this._error;
    }
  };
};
function I(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: s } = n;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (o, i) => {
    var c, l;
    const { message: f } = n;
    return o.code === "invalid_enum_value" ? { message: f ?? i.defaultError } : typeof i.data > "u" ? { message: (c = f ?? r) !== null && c !== void 0 ? c : i.defaultError } : o.code !== "invalid_type" ? { message: i.defaultError } : { message: (l = f ?? t) !== null && l !== void 0 ? l : i.defaultError };
  }, description: s };
}
class V {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Fe(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: Fe(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ge(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Fe(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (At(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    var r;
    const s = {
      common: {
        issues: [],
        async: (r = t == null ? void 0 : t.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Fe(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return Fr(s, a);
  }
  "~validate"(e) {
    var t, r;
    const s = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Fe(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: s });
        return nt(a) ? {
          value: a.value
        } : {
          issues: s.common.issues
        };
      } catch (a) {
        !((r = (t = a == null ? void 0 : a.message) === null || t === void 0 ? void 0 : t.toLowerCase()) === null || r === void 0) && r.includes("encountered") && (this["~standard"].async = !0), s.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: s }).then((a) => nt(a) ? {
      value: a.value
    } : {
      issues: s.common.issues
    });
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Fe(e)
    }, s = this._parse({ data: e, path: r.path, parent: r }), a = await (At(s) ? s : Promise.resolve(s));
    return Fr(r, a);
  }
  refine(e, t) {
    const r = (s) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(s) : t;
    return this._refinement((s, a) => {
      const o = e(s), i = () => a.addIssue({
        code: w.custom,
        ...r(s)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((c) => c ? !0 : (i(), !1)) : o ? !0 : (i(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof t == "function" ? t(r, s) : t), !1));
  }
  _refinement(e) {
    return new Ee({
      schema: this,
      typeName: L.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return ze.create(this, this._def);
  }
  nullable() {
    return Qe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Te.create(this);
  }
  promise() {
    return wt.create(this, this._def);
  }
  or(e) {
    return jt.create([this, e], this._def);
  }
  and(e) {
    return Pt.create(this, e, this._def);
  }
  transform(e) {
    return new Ee({
      ...I(this._def),
      schema: this,
      typeName: L.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Ut({
      ...I(this._def),
      innerType: this,
      defaultValue: t,
      typeName: L.ZodDefault
    });
  }
  brand() {
    return new cr({
      typeName: L.ZodBranded,
      type: this,
      ...I(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Zt({
      ...I(this._def),
      innerType: this,
      catchValue: t,
      typeName: L.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Gt.create(this, e);
  }
  readonly() {
    return Bt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Nl = /^c[^\s-]{8,}$/i, Ol = /^[0-9a-z]+$/, Tl = /^[0-9A-HJKMNP-TV-Z]{26}$/i, El = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Cl = /^[a-z0-9_-]{21}$/i, Rl = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Al = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, zl = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Dl = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let jn;
const Ll = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, jl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Pl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Il = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Vl = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Fl = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, aa = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ml = new RegExp(`^${aa}$`);
function oa(n) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return n.precision ? e = `${e}\\.\\d{${n.precision}}` : n.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Ul(n) {
  return new RegExp(`^${oa(n)}$`);
}
function ia(n) {
  let e = `${aa}T${oa(n)}`;
  const t = [];
  return t.push(n.local ? "Z?" : "Z"), n.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function Zl(n, e) {
  return !!((e === "v4" || !e) && Ll.test(n) || (e === "v6" || !e) && Pl.test(n));
}
function Bl(n, e) {
  if (!Rl.test(n))
    return !1;
  try {
    const [t] = n.split("."), r = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || !s.typ || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function ql(n, e) {
  return !!((e === "v4" || !e) && jl.test(n) || (e === "v6" || !e) && Il.test(n));
}
class Oe extends V {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== E.string) {
      const a = this._getOrReturnCtx(e);
      return N(a, {
        code: w.invalid_type,
        expected: E.string,
        received: a.parsedType
      }), j;
    }
    const r = new ge();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), N(s, {
          code: w.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), N(s, {
          code: w.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const o = e.data.length > a.value, i = e.data.length < a.value;
        (o || i) && (s = this._getOrReturnCtx(e, s), o ? N(s, {
          code: w.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : i && N(s, {
          code: w.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        zl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "email",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        jn || (jn = new RegExp(Dl, "u")), jn.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "emoji",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        El.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "uuid",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        Cl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "nanoid",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        Nl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "cuid",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        Ol.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "cuid2",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        Tl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
          validation: "ulid",
          code: w.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), N(s, {
            validation: "url",
            code: w.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "regex",
        code: w.invalid_string,
        message: a.message
      }), r.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), r.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "datetime" ? ia(a).test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: "datetime",
        message: a.message
      }), r.dirty()) : a.kind === "date" ? Ml.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: "date",
        message: a.message
      }), r.dirty()) : a.kind === "time" ? Ul(a).test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.invalid_string,
        validation: "time",
        message: a.message
      }), r.dirty()) : a.kind === "duration" ? Al.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "duration",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "ip" ? Zl(e.data, a.version) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "ip",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "jwt" ? Bl(e.data, a.alg) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "jwt",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "cidr" ? ql(e.data, a.version) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "cidr",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "base64" ? Vl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "base64",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "base64url" ? Fl.test(e.data) || (s = this._getOrReturnCtx(e, s), N(s, {
        validation: "base64url",
        code: w.invalid_string,
        message: a.message
      }), r.dirty()) : q.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((s) => e.test(s), {
      validation: t,
      code: w.invalid_string,
      ...C.errToObj(r)
    });
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...C.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...C.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...C.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...C.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...C.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...C.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...C.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...C.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...C.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...C.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...C.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...C.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...C.errToObj(e) });
  }
  datetime(e) {
    var t, r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (t = e == null ? void 0 : e.offset) !== null && t !== void 0 ? t : !1,
      local: (r = e == null ? void 0 : e.local) !== null && r !== void 0 ? r : !1,
      ...C.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...C.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...C.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...C.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...C.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...C.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...C.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...C.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...C.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...C.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, C.errToObj(e));
  }
  trim() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Oe.create = (n) => {
  var e;
  return new Oe({
    checks: [],
    typeName: L.ZodString,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ...I(n)
  });
};
function Hl(n, e) {
  const t = (n.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = t > r ? t : r, a = parseInt(n.toFixed(s).replace(".", "")), o = parseInt(e.toFixed(s).replace(".", ""));
  return a % o / Math.pow(10, s);
}
class Ke extends V {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== E.number) {
      const a = this._getOrReturnCtx(e);
      return N(a, {
        code: w.invalid_type,
        expected: E.number,
        received: a.parsedType
      }), j;
    }
    let r;
    const s = new ge();
    for (const a of this._def.checks)
      a.kind === "int" ? q.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? Hl(e.data, a.value) !== 0 && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.not_finite,
        message: a.message
      }), s.dirty()) : q.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, C.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, C.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, C.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, C.toString(t));
  }
  setLimit(e, t, r, s) {
    return new Ke({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: C.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: C.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: C.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: C.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: C.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: C.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: C.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: C.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: C.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: C.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && q.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
Ke.create = (n) => new Ke({
  checks: [],
  typeName: L.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...I(n)
});
class Ye extends V {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== E.bigint)
      return this._getInvalidInput(e);
    let r;
    const s = new ge();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), N(r, {
        code: w.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : q.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return N(t, {
      code: w.invalid_type,
      expected: E.bigint,
      received: t.parsedType
    }), j;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, C.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, C.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, C.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, C.toString(t));
  }
  setLimit(e, t, r, s) {
    return new Ye({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: C.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ye({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: C.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: C.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: C.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: C.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: C.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Ye.create = (n) => {
  var e;
  return new Ye({
    checks: [],
    typeName: L.ZodBigInt,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ...I(n)
  });
};
class zt extends V {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== E.boolean) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.boolean,
        received: r.parsedType
      }), j;
    }
    return me(e.data);
  }
}
zt.create = (n) => new zt({
  typeName: L.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...I(n)
});
class rt extends V {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== E.date) {
      const a = this._getOrReturnCtx(e);
      return N(a, {
        code: w.invalid_type,
        expected: E.date,
        received: a.parsedType
      }), j;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return N(a, {
        code: w.invalid_date
      }), j;
    }
    const r = new ge();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), N(s, {
        code: w.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : q.assertNever(a);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new rt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: C.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: C.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
rt.create = (n) => new rt({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: L.ZodDate,
  ...I(n)
});
class hn extends V {
  _parse(e) {
    if (this._getType(e) !== E.symbol) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.symbol,
        received: r.parsedType
      }), j;
    }
    return me(e.data);
  }
}
hn.create = (n) => new hn({
  typeName: L.ZodSymbol,
  ...I(n)
});
class Dt extends V {
  _parse(e) {
    if (this._getType(e) !== E.undefined) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.undefined,
        received: r.parsedType
      }), j;
    }
    return me(e.data);
  }
}
Dt.create = (n) => new Dt({
  typeName: L.ZodUndefined,
  ...I(n)
});
class Lt extends V {
  _parse(e) {
    if (this._getType(e) !== E.null) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.null,
        received: r.parsedType
      }), j;
    }
    return me(e.data);
  }
}
Lt.create = (n) => new Lt({
  typeName: L.ZodNull,
  ...I(n)
});
class yt extends V {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return me(e.data);
  }
}
yt.create = (n) => new yt({
  typeName: L.ZodAny,
  ...I(n)
});
class tt extends V {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return me(e.data);
  }
}
tt.create = (n) => new tt({
  typeName: L.ZodUnknown,
  ...I(n)
});
class Ze extends V {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return N(t, {
      code: w.invalid_type,
      expected: E.never,
      received: t.parsedType
    }), j;
  }
}
Ze.create = (n) => new Ze({
  typeName: L.ZodNever,
  ...I(n)
});
class gn extends V {
  _parse(e) {
    if (this._getType(e) !== E.undefined) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.void,
        received: r.parsedType
      }), j;
    }
    return me(e.data);
  }
}
gn.create = (n) => new gn({
  typeName: L.ZodVoid,
  ...I(n)
});
class Te extends V {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), s = this._def;
    if (t.parsedType !== E.array)
      return N(t, {
        code: w.invalid_type,
        expected: E.array,
        received: t.parsedType
      }), j;
    if (s.exactLength !== null) {
      const o = t.data.length > s.exactLength.value, i = t.data.length < s.exactLength.value;
      (o || i) && (N(t, {
        code: o ? w.too_big : w.too_small,
        minimum: i ? s.exactLength.value : void 0,
        maximum: o ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && t.data.length < s.minLength.value && (N(t, {
      code: w.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && t.data.length > s.maxLength.value && (N(t, {
      code: w.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((o, i) => s.type._parseAsync(new De(t, o, t.path, i)))).then((o) => ge.mergeArray(r, o));
    const a = [...t.data].map((o, i) => s.type._parseSync(new De(t, o, t.path, i)));
    return ge.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new Te({
      ...this._def,
      minLength: { value: e, message: C.toString(t) }
    });
  }
  max(e, t) {
    return new Te({
      ...this._def,
      maxLength: { value: e, message: C.toString(t) }
    });
  }
  length(e, t) {
    return new Te({
      ...this._def,
      exactLength: { value: e, message: C.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Te.create = (n, e) => new Te({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: L.ZodArray,
  ...I(e)
});
function ft(n) {
  if (n instanceof te) {
    const e = {};
    for (const t in n.shape) {
      const r = n.shape[t];
      e[t] = ze.create(ft(r));
    }
    return new te({
      ...n._def,
      shape: () => e
    });
  } else return n instanceof Te ? new Te({
    ...n._def,
    type: ft(n.element)
  }) : n instanceof ze ? ze.create(ft(n.unwrap())) : n instanceof Qe ? Qe.create(ft(n.unwrap())) : n instanceof Le ? Le.create(n.items.map((e) => ft(e))) : n;
}
class te extends V {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = q.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== E.object) {
      const l = this._getOrReturnCtx(e);
      return N(l, {
        code: w.invalid_type,
        expected: E.object,
        received: l.parsedType
      }), j;
    }
    const { status: r, ctx: s } = this._processInputParams(e), { shape: a, keys: o } = this._getCached(), i = [];
    if (!(this._def.catchall instanceof Ze && this._def.unknownKeys === "strip"))
      for (const l in s.data)
        o.includes(l) || i.push(l);
    const c = [];
    for (const l of o) {
      const f = a[l], d = s.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: f._parse(new De(s, d, s.path, l)),
        alwaysSet: l in s.data
      });
    }
    if (this._def.catchall instanceof Ze) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const f of i)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: s.data[f] }
          });
      else if (l === "strict")
        i.length > 0 && (N(s, {
          code: w.unrecognized_keys,
          keys: i
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const f of i) {
        const d = s.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: l._parse(
            new De(s, d, s.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const f of c) {
        const d = await f.key, u = await f.value;
        l.push({
          key: d,
          value: u,
          alwaysSet: f.alwaysSet
        });
      }
      return l;
    }).then((l) => ge.mergeObjectSync(r, l)) : ge.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return C.errToObj, new te({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var s, a, o, i;
          const c = (o = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, t, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: (i = C.errToObj(e).message) !== null && i !== void 0 ? i : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new te({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new te({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new te({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new te({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: L.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new te({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    return q.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    }), new te({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    return q.objectKeys(this.shape).forEach((r) => {
      e[r] || (t[r] = this.shape[r]);
    }), new te({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ft(this);
  }
  partial(e) {
    const t = {};
    return q.objectKeys(this.shape).forEach((r) => {
      const s = this.shape[r];
      e && !e[r] ? t[r] = s : t[r] = s.optional();
    }), new te({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    return q.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof ze; )
          a = a._def.innerType;
        t[r] = a;
      }
    }), new te({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return la(q.objectKeys(this.shape));
  }
}
te.create = (n, e) => new te({
  shape: () => n,
  unknownKeys: "strip",
  catchall: Ze.create(),
  typeName: L.ZodObject,
  ...I(e)
});
te.strictCreate = (n, e) => new te({
  shape: () => n,
  unknownKeys: "strict",
  catchall: Ze.create(),
  typeName: L.ZodObject,
  ...I(e)
});
te.lazycreate = (n, e) => new te({
  shape: n,
  unknownKeys: "strip",
  catchall: Ze.create(),
  typeName: L.ZodObject,
  ...I(e)
});
class jt extends V {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function s(a) {
      for (const i of a)
        if (i.result.status === "valid")
          return i.result;
      for (const i of a)
        if (i.result.status === "dirty")
          return t.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((i) => new we(i.ctx.common.issues));
      return N(t, {
        code: w.invalid_union,
        unionErrors: o
      }), j;
    }
    if (t.common.async)
      return Promise.all(r.map(async (a) => {
        const o = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: t.data,
            path: t.path,
            parent: o
          }),
          ctx: o
        };
      })).then(s);
    {
      let a;
      const o = [];
      for (const c of r) {
        const l = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, f = c._parseSync({
          data: t.data,
          path: t.path,
          parent: l
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !a && (a = { result: f, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (a)
        return t.common.issues.push(...a.ctx.common.issues), a.result;
      const i = o.map((c) => new we(c));
      return N(t, {
        code: w.invalid_union,
        unionErrors: i
      }), j;
    }
  }
  get options() {
    return this._def.options;
  }
}
jt.create = (n, e) => new jt({
  options: n,
  typeName: L.ZodUnion,
  ...I(e)
});
const Ve = (n) => n instanceof Vt ? Ve(n.schema) : n instanceof Ee ? Ve(n.innerType()) : n instanceof Ft ? [n.value] : n instanceof Je ? n.options : n instanceof Mt ? q.objectValues(n.enum) : n instanceof Ut ? Ve(n._def.innerType) : n instanceof Dt ? [void 0] : n instanceof Lt ? [null] : n instanceof ze ? [void 0, ...Ve(n.unwrap())] : n instanceof Qe ? [null, ...Ve(n.unwrap())] : n instanceof cr || n instanceof Bt ? Ve(n.unwrap()) : n instanceof Zt ? Ve(n._def.innerType) : [];
class $n extends V {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== E.object)
      return N(t, {
        code: w.invalid_type,
        expected: E.object,
        received: t.parsedType
      }), j;
    const r = this.discriminator, s = t.data[r], a = this.optionsMap.get(s);
    return a ? t.common.async ? a._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : a._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (N(t, {
      code: w.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), j);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, r) {
    const s = /* @__PURE__ */ new Map();
    for (const a of t) {
      const o = Ve(a.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const i of o) {
        if (s.has(i))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(i)}`);
        s.set(i, a);
      }
    }
    return new $n({
      typeName: L.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: s,
      ...I(r)
    });
  }
}
function Gn(n, e) {
  const t = Fe(n), r = Fe(e);
  if (n === e)
    return { valid: !0, data: n };
  if (t === E.object && r === E.object) {
    const s = q.objectKeys(e), a = q.objectKeys(n).filter((i) => s.indexOf(i) !== -1), o = { ...n, ...e };
    for (const i of a) {
      const c = Gn(n[i], e[i]);
      if (!c.valid)
        return { valid: !1 };
      o[i] = c.data;
    }
    return { valid: !0, data: o };
  } else if (t === E.array && r === E.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a], i = e[a], c = Gn(o, i);
      if (!c.valid)
        return { valid: !1 };
      s.push(c.data);
    }
    return { valid: !0, data: s };
  } else return t === E.date && r === E.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class Pt extends V {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = (a, o) => {
      if (Hn(a) || Hn(o))
        return j;
      const i = Gn(a.value, o.value);
      return i.valid ? ((Wn(a) || Wn(o)) && t.dirty(), { status: t.value, value: i.data }) : (N(r, {
        code: w.invalid_intersection_types
      }), j);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, o]) => s(a, o)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Pt.create = (n, e, t) => new Pt({
  left: n,
  right: e,
  typeName: L.ZodIntersection,
  ...I(t)
});
class Le extends V {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== E.array)
      return N(r, {
        code: w.invalid_type,
        expected: E.array,
        received: r.parsedType
      }), j;
    if (r.data.length < this._def.items.length)
      return N(r, {
        code: w.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), j;
    !this._def.rest && r.data.length > this._def.items.length && (N(r, {
      code: w.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const a = [...r.data].map((o, i) => {
      const c = this._def.items[i] || this._def.rest;
      return c ? c._parse(new De(r, o, r.path, i)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(a).then((o) => ge.mergeArray(t, o)) : ge.mergeArray(t, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Le({
      ...this._def,
      rest: e
    });
  }
}
Le.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Le({
    items: n,
    typeName: L.ZodTuple,
    rest: null,
    ...I(e)
  });
};
class It extends V {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== E.object)
      return N(r, {
        code: w.invalid_type,
        expected: E.object,
        received: r.parsedType
      }), j;
    const s = [], a = this._def.keyType, o = this._def.valueType;
    for (const i in r.data)
      s.push({
        key: a._parse(new De(r, i, r.path, i)),
        value: o._parse(new De(r, r.data[i], r.path, i)),
        alwaysSet: i in r.data
      });
    return r.common.async ? ge.mergeObjectAsync(t, s) : ge.mergeObjectSync(t, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, r) {
    return t instanceof V ? new It({
      keyType: e,
      valueType: t,
      typeName: L.ZodRecord,
      ...I(r)
    }) : new It({
      keyType: Oe.create(),
      valueType: e,
      typeName: L.ZodRecord,
      ...I(t)
    });
  }
}
class pn extends V {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== E.map)
      return N(r, {
        code: w.invalid_type,
        expected: E.map,
        received: r.parsedType
      }), j;
    const s = this._def.keyType, a = this._def.valueType, o = [...r.data.entries()].map(([i, c], l) => ({
      key: s._parse(new De(r, i, r.path, [l, "key"])),
      value: a._parse(new De(r, c, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const i = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of o) {
          const l = await c.key, f = await c.value;
          if (l.status === "aborted" || f.status === "aborted")
            return j;
          (l.status === "dirty" || f.status === "dirty") && t.dirty(), i.set(l.value, f.value);
        }
        return { status: t.value, value: i };
      });
    } else {
      const i = /* @__PURE__ */ new Map();
      for (const c of o) {
        const l = c.key, f = c.value;
        if (l.status === "aborted" || f.status === "aborted")
          return j;
        (l.status === "dirty" || f.status === "dirty") && t.dirty(), i.set(l.value, f.value);
      }
      return { status: t.value, value: i };
    }
  }
}
pn.create = (n, e, t) => new pn({
  valueType: e,
  keyType: n,
  typeName: L.ZodMap,
  ...I(t)
});
class st extends V {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== E.set)
      return N(r, {
        code: w.invalid_type,
        expected: E.set,
        received: r.parsedType
      }), j;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (N(r, {
      code: w.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), t.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (N(r, {
      code: w.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), t.dirty());
    const a = this._def.valueType;
    function o(c) {
      const l = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return j;
        f.status === "dirty" && t.dirty(), l.add(f.value);
      }
      return { status: t.value, value: l };
    }
    const i = [...r.data.values()].map((c, l) => a._parse(new De(r, c, r.path, l)));
    return r.common.async ? Promise.all(i).then((c) => o(c)) : o(i);
  }
  min(e, t) {
    return new st({
      ...this._def,
      minSize: { value: e, message: C.toString(t) }
    });
  }
  max(e, t) {
    return new st({
      ...this._def,
      maxSize: { value: e, message: C.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
st.create = (n, e) => new st({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: L.ZodSet,
  ...I(e)
});
class gt extends V {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== E.function)
      return N(t, {
        code: w.invalid_type,
        expected: E.function,
        received: t.parsedType
      }), j;
    function r(i, c) {
      return dn({
        data: i,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          un(),
          vt
        ].filter((l) => !!l),
        issueData: {
          code: w.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function s(i, c) {
      return dn({
        data: i,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          un(),
          vt
        ].filter((l) => !!l),
        issueData: {
          code: w.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: t.common.contextualErrorMap }, o = t.data;
    if (this._def.returns instanceof wt) {
      const i = this;
      return me(async function(...c) {
        const l = new we([]), f = await i._def.args.parseAsync(c, a).catch((g) => {
          throw l.addIssue(r(c, g)), l;
        }), d = await Reflect.apply(o, this, f);
        return await i._def.returns._def.type.parseAsync(d, a).catch((g) => {
          throw l.addIssue(s(d, g)), l;
        });
      });
    } else {
      const i = this;
      return me(function(...c) {
        const l = i._def.args.safeParse(c, a);
        if (!l.success)
          throw new we([r(c, l.error)]);
        const f = Reflect.apply(o, this, l.data), d = i._def.returns.safeParse(f, a);
        if (!d.success)
          throw new we([s(f, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new gt({
      ...this._def,
      args: Le.create(e).rest(tt.create())
    });
  }
  returns(e) {
    return new gt({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, r) {
    return new gt({
      args: e || Le.create([]).rest(tt.create()),
      returns: t || tt.create(),
      typeName: L.ZodFunction,
      ...I(r)
    });
  }
}
class Vt extends V {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Vt.create = (n, e) => new Vt({
  getter: n,
  typeName: L.ZodLazy,
  ...I(e)
});
class Ft extends V {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return N(t, {
        received: t.data,
        code: w.invalid_literal,
        expected: this._def.value
      }), j;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Ft.create = (n, e) => new Ft({
  value: n,
  typeName: L.ZodLiteral,
  ...I(e)
});
function la(n, e) {
  return new Je({
    values: n,
    typeName: L.ZodEnum,
    ...I(e)
  });
}
class Je extends V {
  constructor() {
    super(...arguments), Nt.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return N(t, {
        expected: q.joinValues(r),
        received: t.parsedType,
        code: w.invalid_type
      }), j;
    }
    if (fn(this, Nt) || sa(this, Nt, new Set(this._def.values)), !fn(this, Nt).has(e.data)) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return N(t, {
        received: t.data,
        code: w.invalid_enum_value,
        options: r
      }), j;
    }
    return me(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return Je.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return Je.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...t
    });
  }
}
Nt = /* @__PURE__ */ new WeakMap();
Je.create = la;
class Mt extends V {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const t = q.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== E.string && r.parsedType !== E.number) {
      const s = q.objectValues(t);
      return N(r, {
        expected: q.joinValues(s),
        received: r.parsedType,
        code: w.invalid_type
      }), j;
    }
    if (fn(this, Ot) || sa(this, Ot, new Set(q.getValidEnumValues(this._def.values))), !fn(this, Ot).has(e.data)) {
      const s = q.objectValues(t);
      return N(r, {
        received: r.data,
        code: w.invalid_enum_value,
        options: s
      }), j;
    }
    return me(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Mt.create = (n, e) => new Mt({
  values: n,
  typeName: L.ZodNativeEnum,
  ...I(e)
});
class wt extends V {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== E.promise && t.common.async === !1)
      return N(t, {
        code: w.invalid_type,
        expected: E.promise,
        received: t.parsedType
      }), j;
    const r = t.parsedType === E.promise ? t.data : Promise.resolve(t.data);
    return me(r.then((s) => this._def.type.parseAsync(s, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
wt.create = (n, e) => new wt({
  type: n,
  typeName: L.ZodPromise,
  ...I(e)
});
class Ee extends V {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === L.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (o) => {
        N(r, o), o.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const o = s.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(o).then(async (i) => {
          if (t.value === "aborted")
            return j;
          const c = await this._def.schema._parseAsync({
            data: i,
            path: r.path,
            parent: r
          });
          return c.status === "aborted" ? j : c.status === "dirty" || t.value === "dirty" ? ht(c.value) : c;
        });
      {
        if (t.value === "aborted")
          return j;
        const i = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? j : i.status === "dirty" || t.value === "dirty" ? ht(i.value) : i;
      }
    }
    if (s.type === "refinement") {
      const o = (i) => {
        const c = s.refinement(i, a);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return i;
      };
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? j : (i.status === "dirty" && t.dirty(), o(i.value), { status: t.value, value: i.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => i.status === "aborted" ? j : (i.status === "dirty" && t.dirty(), o(i.value).then(() => ({ status: t.value, value: i.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!nt(o))
          return o;
        const i = s.transform(o.value, a);
        if (i instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: i };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => nt(o) ? Promise.resolve(s.transform(o.value, a)).then((i) => ({ status: t.value, value: i })) : o);
    q.assertNever(s);
  }
}
Ee.create = (n, e, t) => new Ee({
  schema: n,
  typeName: L.ZodEffects,
  effect: e,
  ...I(t)
});
Ee.createWithPreprocess = (n, e, t) => new Ee({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: L.ZodEffects,
  ...I(t)
});
class ze extends V {
  _parse(e) {
    return this._getType(e) === E.undefined ? me(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ze.create = (n, e) => new ze({
  innerType: n,
  typeName: L.ZodOptional,
  ...I(e)
});
class Qe extends V {
  _parse(e) {
    return this._getType(e) === E.null ? me(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Qe.create = (n, e) => new Qe({
  innerType: n,
  typeName: L.ZodNullable,
  ...I(e)
});
class Ut extends V {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === E.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ut.create = (n, e) => new Ut({
  innerType: n,
  typeName: L.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...I(e)
});
class Zt extends V {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return At(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new we(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new we(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Zt.create = (n, e) => new Zt({
  innerType: n,
  typeName: L.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...I(e)
});
class mn extends V {
  _parse(e) {
    if (this._getType(e) !== E.nan) {
      const r = this._getOrReturnCtx(e);
      return N(r, {
        code: w.invalid_type,
        expected: E.nan,
        received: r.parsedType
      }), j;
    }
    return { status: "valid", value: e.data };
  }
}
mn.create = (n) => new mn({
  typeName: L.ZodNaN,
  ...I(n)
});
const Wl = Symbol("zod_brand");
class cr extends V {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Gt extends V {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? j : a.status === "dirty" ? (t.dirty(), ht(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? j : s.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new Gt({
      in: e,
      out: t,
      typeName: L.ZodPipeline
    });
  }
}
class Bt extends V {
  _parse(e) {
    const t = this._def.innerType._parse(e), r = (s) => (nt(s) && (s.value = Object.freeze(s.value)), s);
    return At(t) ? t.then((s) => r(s)) : r(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Bt.create = (n, e) => new Bt({
  innerType: n,
  typeName: L.ZodReadonly,
  ...I(e)
});
function Mr(n, e) {
  const t = typeof n == "function" ? n(e) : typeof n == "string" ? { message: n } : n;
  return typeof t == "string" ? { message: t } : t;
}
function ca(n, e = {}, t) {
  return n ? yt.create().superRefine((r, s) => {
    var a, o;
    const i = n(r);
    if (i instanceof Promise)
      return i.then((c) => {
        var l, f;
        if (!c) {
          const d = Mr(e, r), u = (f = (l = d.fatal) !== null && l !== void 0 ? l : t) !== null && f !== void 0 ? f : !0;
          s.addIssue({ code: "custom", ...d, fatal: u });
        }
      });
    if (!i) {
      const c = Mr(e, r), l = (o = (a = c.fatal) !== null && a !== void 0 ? a : t) !== null && o !== void 0 ? o : !0;
      s.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : yt.create();
}
const Gl = {
  object: te.lazycreate
};
var L;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline", n.ZodReadonly = "ZodReadonly";
})(L || (L = {}));
const Kl = (n, e = {
  message: `Input not instance of ${n.name}`
}) => ca((t) => t instanceof n, e), ua = Oe.create, da = Ke.create, Yl = mn.create, Jl = Ye.create, fa = zt.create, Ql = rt.create, Xl = hn.create, ec = Dt.create, tc = Lt.create, nc = yt.create, rc = tt.create, sc = Ze.create, ac = gn.create, oc = Te.create, ic = te.create, lc = te.strictCreate, cc = jt.create, uc = $n.create, dc = Pt.create, fc = Le.create, hc = It.create, gc = pn.create, pc = st.create, mc = gt.create, _c = Vt.create, bc = Ft.create, vc = Je.create, yc = Mt.create, wc = wt.create, Ur = Ee.create, xc = ze.create, kc = Qe.create, Sc = Ee.createWithPreprocess, $c = Gt.create, Nc = () => ua().optional(), Oc = () => da().optional(), Tc = () => fa().optional(), Ec = {
  string: (n) => Oe.create({ ...n, coerce: !0 }),
  number: (n) => Ke.create({ ...n, coerce: !0 }),
  boolean: (n) => zt.create({
    ...n,
    coerce: !0
  }),
  bigint: (n) => Ye.create({ ...n, coerce: !0 }),
  date: (n) => rt.create({ ...n, coerce: !0 })
}, Cc = j;
var Pn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: vt,
  setErrorMap: Sl,
  getErrorMap: un,
  makeIssue: dn,
  EMPTY_PATH: $l,
  addIssueToContext: N,
  ParseStatus: ge,
  INVALID: j,
  DIRTY: ht,
  OK: me,
  isAborted: Hn,
  isDirty: Wn,
  isValid: nt,
  isAsync: At,
  get util() {
    return q;
  },
  get objectUtil() {
    return qn;
  },
  ZodParsedType: E,
  getParsedType: Fe,
  ZodType: V,
  datetimeRegex: ia,
  ZodString: Oe,
  ZodNumber: Ke,
  ZodBigInt: Ye,
  ZodBoolean: zt,
  ZodDate: rt,
  ZodSymbol: hn,
  ZodUndefined: Dt,
  ZodNull: Lt,
  ZodAny: yt,
  ZodUnknown: tt,
  ZodNever: Ze,
  ZodVoid: gn,
  ZodArray: Te,
  ZodObject: te,
  ZodUnion: jt,
  ZodDiscriminatedUnion: $n,
  ZodIntersection: Pt,
  ZodTuple: Le,
  ZodRecord: It,
  ZodMap: pn,
  ZodSet: st,
  ZodFunction: gt,
  ZodLazy: Vt,
  ZodLiteral: Ft,
  ZodEnum: Je,
  ZodNativeEnum: Mt,
  ZodPromise: wt,
  ZodEffects: Ee,
  ZodTransformer: Ee,
  ZodOptional: ze,
  ZodNullable: Qe,
  ZodDefault: Ut,
  ZodCatch: Zt,
  ZodNaN: mn,
  BRAND: Wl,
  ZodBranded: cr,
  ZodPipeline: Gt,
  ZodReadonly: Bt,
  custom: ca,
  Schema: V,
  ZodSchema: V,
  late: Gl,
  get ZodFirstPartyTypeKind() {
    return L;
  },
  coerce: Ec,
  any: nc,
  array: oc,
  bigint: Jl,
  boolean: fa,
  date: Ql,
  discriminatedUnion: uc,
  effect: Ur,
  enum: vc,
  function: mc,
  instanceof: Kl,
  intersection: dc,
  lazy: _c,
  literal: bc,
  map: gc,
  nan: Yl,
  nativeEnum: yc,
  never: sc,
  null: tc,
  nullable: kc,
  number: da,
  object: ic,
  oboolean: Tc,
  onumber: Oc,
  optional: xc,
  ostring: Nc,
  pipeline: $c,
  preprocess: Sc,
  promise: wc,
  record: hc,
  set: pc,
  strictObject: lc,
  string: ua,
  symbol: Xl,
  transformer: Ur,
  tuple: fc,
  undefined: ec,
  union: cc,
  unknown: rc,
  void: ac,
  NEVER: Cc,
  ZodIssueCode: w,
  quotelessJson: kl,
  ZodError: we
});
const _n = "9", Rc = Pn.object({
  reasonId: Pn.string({ required_error: "reasons_for_cancellation_needed" }),
  comment: Pn.string().optional()
}).refine((n) => !(n.reasonId === _n && !n.comment), {
  message: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((n) => !(n.reasonId === _n && n.comment && n.comment.length > 255), {
  message: "common:error.characters_max_limit",
  path: ["comment"]
});
function Ac({ onClickContinue: n, cancellationReasons: e, conversation: t, user: r }) {
  const { t: s } = sr(["conversations", "common"]), [a, o] = Me(!1), [i, c] = Me(!1), l = async (m) => {
    try {
      o(!0), await Oa(t.id, m.reasonId, m.comment);
      const b = e.find((y) => y.id.toString() === m.reasonId);
      Bg(
        {
          exchange_status: "cancelled",
          cancellation_reason: b == null ? void 0 : b.name,
          exchange_type: t.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: r.is_he_collection
        },
        { eventCallback: () => n(), eventTimeout: 2e3 }
      );
    } catch {
      c(!0);
    } finally {
      o(!1);
    }
  }, f = Ha({
    resolver: xl(Rc)
  }), { watch: d } = f, u = is(
    () => e.map((m) => ({
      id: m.id.toString(),
      name: s(`reasons_for_cancellation_${m.name}`)
    })),
    [e, s]
  ), g = d("reasonId") === _n;
  return {
    isLoading: a,
    requestHasError: i,
    onSubmitCancellationForm: l,
    cancellationReasonsRadioItems: u,
    displayCommentTextarea: g,
    cancellationForm: f
  };
}
function zc({ onClickContinue: n, cancellationReasons: e, conversation: t, user: r }) {
  const { url: s } = lr(`/conversations/${t.id}`), { t: a } = sr(["conversations", "common"]), { isDesktop: o } = ta(), {
    isLoading: i,
    requestHasError: c,
    onSubmitCancellationForm: l,
    cancellationReasonsRadioItems: f,
    displayCommentTextarea: d,
    cancellationForm: {
      control: u,
      handleSubmit: g,
      setValue: m,
      formState: { errors: b }
    }
  } = Ac({ onClickContinue: n, cancellationReasons: e, conversation: t, user: r });
  return /* @__PURE__ */ Q(Qs, { children: [
    /* @__PURE__ */ Q(cn, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ v(Es, { level: 2, children: a("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ v("form", { onSubmit: g(l), children: /* @__PURE__ */ Q(Oi, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ v(
          vr,
          {
            name: "reasonId",
            control: u,
            render: ({ field: y }) => {
              var R;
              return /* @__PURE__ */ v(
                Bn,
                {
                  ...y,
                  errorMessage: (R = b.reasonId) != null && R.message ? a(b.reasonId.message) : void 0,
                  onChange: (k) => {
                    k !== _n && d && m("comment", ""), y.onChange(k);
                  },
                  label: a("cancellation-page.reason_step.checboxes_label"),
                  children: f.map((k) => /* @__PURE__ */ v(Bn.Item, { value: k.id, id: k.id, label: k.name }, k.id))
                }
              );
            }
          }
        ),
        d && /* @__PURE__ */ v(
          vr,
          {
            name: "comment",
            control: u,
            render: ({ field: y }) => {
              var R, k, F;
              return /* @__PURE__ */ v(
                Pi,
                {
                  placeholder: a("cancellation-page.reason_step.comment_placeholder"),
                  id: "reason-comment",
                  status: (R = b.comment) != null && R.message ? "error" : void 0,
                  message: (k = b.comment) != null && k.message ? a((F = b.comment) == null ? void 0 : F.message, { limit: 255 }) : void 0,
                  maxLength: 255,
                  ...y
                }
              );
            }
          }
        ),
        c && !i && /* @__PURE__ */ Q(Bi, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ v("span", { style: { fontWeight: "bold" }, children: a("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ v(Rt, { children: a("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ Q(Ts, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ v(_t, { isLoading: i, disabled: i, color: "destructive", type: "submit", children: a("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ v(_t, { disabled: i, color: "tertiary", href: s, children: a("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }),
    o && /* @__PURE__ */ v(cn, { size: 6, centerContent: !0, children: /* @__PURE__ */ v(
      Js,
      {
        width: "full",
        src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
        alt: "cancellation-warning"
      }
    ) })
  ] });
}
function Dc({ onClickContinue: n, conversation: e }) {
  const { t } = sr("conversations"), { isTablet: r, isMobile: s, isDesktop: a } = ta(), { url: o } = lr(`/conversations/${e.id}`), i = /* @__PURE__ */ Q(Ts, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ v(_t, { onClick: n, children: t("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ v(_t, { color: "tertiary", href: o, children: t("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ Q(Qs, { children: [
    /* @__PURE__ */ Q(cn, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ v(Es, { level: 2, children: t("cancellation-page.cancel-exchange") }),
      /* @__PURE__ */ v(Rt, { children: t("cancellation-page.warning-step.first-warning") }),
      /* @__PURE__ */ v(Rt, { isBold: !0, children: t("cancellation-page.warning-step.second-warning") }),
      a && i
    ] }),
    /* @__PURE__ */ Q(cn, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ v(
        Js,
        {
          width: "full",
          src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
          alt: "cancellation-warning"
        }
      ),
      (r || s) && i
    ] })
  ] });
}
const ha = "https://www.homeexchange.com/blog/calculate-the-carbon-footprint-of-your-trip/", Lc = {
  fr: "https://www.homeexchange.fr/blog/calculez-lempreinte-carbone-de-votre-voyage/",
  es: "https://es.homeexchange.com/es/blog/calcula-la-huella-de-carbono-de-tus-viajes/",
  en: ha
};
function ep({
  className: n,
  title: e,
  description: t,
  locale: r,
  ctaText: s,
  onClickCTA: a
}) {
  return /* @__PURE__ */ v(
    Gi,
    {
      className: n,
      color: "info",
      title: e,
      description: t,
      image: {
        alt: "transportation-banner-logo",
        imageSrc: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo.svg",
        imageSrcMobile: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo-small.svg"
      },
      cta: {
        color: "eco-green",
        text: s,
        onClick: async () => {
          await a(), window.open(Lc[r] || ha, "_blank");
        }
      }
    }
  );
}
const jc = (n, e, t, r) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: s, ...a } = {}, o = (i) => {
    s && typeof s == "function" && i.startsWith("GTM-") && s(i);
  };
  window.dataLayer.push({
    event: "page_view",
    event_data: {
      collection: t,
      method: null,
      text: null
    },
    page_data: {
      location: location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: n,
      profile: e
    },
    eventCallback: o,
    ...a
  });
}, ga = (n, e, t) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: r, ...s } = t || {}, a = (o) => {
    r && typeof r == "function" && o.startsWith("GTM-") && r(o);
  };
  window.dataLayer.push({
    event: n,
    event_data: e,
    ...s,
    eventCallback: a
  }), !window.google_tag_manager && t != null && t.eventCallback && typeof t.eventCallback == "function" && t.eventCallback();
}, Pc = (n, e, t) => {
  ga("funnel_progress", {
    funnel_name: n,
    funnel_step: e,
    ...t
  });
}, Ic = (n) => n.subscriptionEndOn ? n.isHeCollection ? "member_collection" : new Date(n.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", P = (n) => typeof n == "string", $t = () => {
  let n, e;
  const t = new Promise((r, s) => {
    n = r, e = s;
  });
  return t.resolve = n, t.reject = e, t;
}, Zr = (n) => n == null ? "" : "" + n, Vc = (n, e, t) => {
  n.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}, Fc = /###/g, Br = (n) => n && n.indexOf("###") > -1 ? n.replace(Fc, ".") : n, qr = (n) => !n || P(n), Ct = (n, e, t) => {
  const r = P(e) ? e.split(".") : e;
  let s = 0;
  for (; s < r.length - 1; ) {
    if (qr(n)) return {};
    const a = Br(r[s]);
    !n[a] && t && (n[a] = new t()), Object.prototype.hasOwnProperty.call(n, a) ? n = n[a] : n = {}, ++s;
  }
  return qr(n) ? {} : {
    obj: n,
    k: Br(r[s])
  };
}, Hr = (n, e, t) => {
  const {
    obj: r,
    k: s
  } = Ct(n, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[s] = t;
    return;
  }
  let a = e[e.length - 1], o = e.slice(0, e.length - 1), i = Ct(n, o, Object);
  for (; i.obj === void 0 && o.length; )
    a = `${o[o.length - 1]}.${a}`, o = o.slice(0, o.length - 1), i = Ct(n, o, Object), i != null && i.obj && typeof i.obj[`${i.k}.${a}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${a}`] = t;
}, Mc = (n, e, t, r) => {
  const {
    obj: s,
    k: a
  } = Ct(n, e, Object);
  s[a] = s[a] || [], s[a].push(t);
}, bn = (n, e) => {
  const {
    obj: t,
    k: r
  } = Ct(n, e);
  if (t && Object.prototype.hasOwnProperty.call(t, r))
    return t[r];
}, Uc = (n, e, t) => {
  const r = bn(n, t);
  return r !== void 0 ? r : bn(e, t);
}, pa = (n, e, t) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in n ? P(n[r]) || n[r] instanceof String || P(e[r]) || e[r] instanceof String ? t && (n[r] = e[r]) : pa(n[r], e[r], t) : n[r] = e[r]);
  return n;
}, ut = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Zc = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Bc = (n) => P(n) ? n.replace(/[&<>"'\/]/g, (e) => Zc[e]) : n;
class qc {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const Hc = [" ", ",", "?", "!", ";"], Wc = new qc(20), Gc = (n, e, t) => {
  e = e || "", t = t || "";
  const r = Hc.filter((o) => e.indexOf(o) < 0 && t.indexOf(o) < 0);
  if (r.length === 0) return !0;
  const s = Wc.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let a = !s.test(n);
  if (!a) {
    const o = n.indexOf(t);
    o > 0 && !s.test(n.substring(0, o)) && (a = !0);
  }
  return a;
}, Kn = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n) return;
  if (n[e])
    return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : void 0;
  const r = e.split(t);
  let s = n;
  for (let a = 0; a < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let o, i = "";
    for (let c = a; c < r.length; ++c)
      if (c !== a && (i += t), i += r[c], o = s[i], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && c < r.length - 1)
          continue;
        a += c - a + 1;
        break;
      }
    s = o;
  }
  return s;
}, vn = (n) => n == null ? void 0 : n.replace("_", "-"), Kc = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    var t, r;
    (r = (t = console == null ? void 0 : console[n]) == null ? void 0 : t.apply) == null || r.call(t, console, e);
  }
};
class yn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Kc, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, s) {
    return s && !this.debug ? null : (P(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new yn(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new yn(this.logger, e);
  }
}
var Ae = new yn();
class Nn {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(t) || 0;
      this.observers[r].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [i, c] = o;
      for (let l = 0; l < c; l++)
        i(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [i, c] = o;
      for (let l = 0; l < c; l++)
        i.apply(i, [e, ...r]);
    });
  }
}
class Wr extends Nn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    var l, f;
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, o = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    e.indexOf(".") > -1 ? i = e.split(".") : (i = [e, t], r && (Array.isArray(r) ? i.push(...r) : P(r) && a ? i.push(...r.split(a)) : i.push(r)));
    const c = bn(this.data, i);
    return !c && !t && !r && e.indexOf(".") > -1 && (e = i[0], t = i[1], r = i.slice(2).join(".")), c || !o || !P(r) ? c : Kn((f = (l = this.data) == null ? void 0 : l[e]) == null ? void 0 : f[t], r, a);
  }
  addResource(e, t, r, s) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let i = [e, t];
    r && (i = i.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (i = e.split("."), s = t, t = i[1]), this.addNamespaces(t), Hr(this.data, i, s), a.silent || this.emit("added", e, t, r, s);
  }
  addResources(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const a in r)
      (P(r[a]) || Array.isArray(r[a])) && this.addResource(e, t, a, r[a], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, s, a) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, i = [e, t];
    e.indexOf(".") > -1 && (i = e.split("."), s = r, r = t, t = i[1]), this.addNamespaces(t);
    let c = bn(this.data, i) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? pa(c, r, a) : c = {
      ...c,
      ...r
    }, Hr(this.data, i, c), o.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ma = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, r, s) {
    return n.forEach((a) => {
      var o;
      e = ((o = this.processors[a]) == null ? void 0 : o.process(e, t, r, s)) ?? e;
    }), e;
  }
};
const Gr = {}, Kr = (n) => !P(n) && typeof n != "boolean" && typeof n != "number";
class wn extends Nn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Vc(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ae.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return (r == null ? void 0 : r.res) !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let a = t.ns || this.options.defaultNS || [];
    const o = r && e.indexOf(r) > -1, i = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Gc(e, r, s);
    if (o && !i) {
      const c = e.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: e,
          namespaces: P(a) ? [a] : a
        };
      const l = e.split(r);
      (r !== s || r === s && this.options.ns.indexOf(l[0]) > -1) && (a = l.shift()), e = l.join(s);
    }
    return {
      key: e,
      namespaces: P(a) ? [a] : a
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, a = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: i
    } = this.extractFromKey(e[e.length - 1], t), c = i[i.length - 1], l = t.lng || this.language, f = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((l == null ? void 0 : l.toLowerCase()) === "cimode") {
      if (f) {
        const G = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${c}${G}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: l,
          usedNS: c,
          usedParams: this.getUsedParamsDetails(t)
        } : `${c}${G}${o}`;
      }
      return s ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: l,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(t)
      } : o;
    }
    const d = this.resolve(e, t);
    let u = d == null ? void 0 : d.res;
    const g = (d == null ? void 0 : d.usedKey) || o, m = (d == null ? void 0 : d.exactUsedKey) || o, b = ["[object Number]", "[object Function]", "[object RegExp]"], y = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, R = !this.i18nFormat || this.i18nFormat.handleAsObject, k = t.count !== void 0 && !P(t.count), F = wn.hasDefaultValue(t), J = k ? this.pluralResolver.getSuffix(l, t.count, t) : "", H = t.ordinal && k ? this.pluralResolver.getSuffix(l, t.count, {
      ordinal: !1
    }) : "", ce = k && !t.ordinal && t.count === 0, X = ce && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${J}`] || t[`defaultValue${H}`] || t.defaultValue;
    let D = u;
    R && !u && F && (D = X);
    const ee = Kr(D), W = Object.prototype.toString.apply(D);
    if (R && D && ee && b.indexOf(W) < 0 && !(P(y) && Array.isArray(D))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const G = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(g, D, {
          ...t,
          ns: i
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = G, d.usedParams = this.getUsedParamsDetails(t), d) : G;
      }
      if (a) {
        const G = Array.isArray(D), z = G ? [] : {}, Z = G ? m : g;
        for (const K in D)
          if (Object.prototype.hasOwnProperty.call(D, K)) {
            const B = `${Z}${a}${K}`;
            F && !u ? z[K] = this.translate(B, {
              ...t,
              defaultValue: Kr(X) ? X[K] : void 0,
              joinArrays: !1,
              ns: i
            }) : z[K] = this.translate(B, {
              ...t,
              joinArrays: !1,
              ns: i
            }), z[K] === B && (z[K] = D[K]);
          }
        u = z;
      }
    } else if (R && P(y) && Array.isArray(u))
      u = u.join(y), u && (u = this.extendTranslation(u, e, t, r));
    else {
      let G = !1, z = !1;
      !this.isValidLookup(u) && F && (G = !0, u = X), this.isValidLookup(u) || (z = !0, u = o);
      const K = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && z ? void 0 : u, B = F && X !== u && this.options.updateMissing;
      if (z || G || B) {
        if (this.logger.log(B ? "updateKey" : "missingKey", l, c, o, B ? X : u), a) {
          const ae = this.resolve(o, {
            ...t,
            keySeparator: !1
          });
          ae && ae.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ue = [];
        const de = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && de && de[0])
          for (let ae = 0; ae < de.length; ae++)
            ue.push(de[ae]);
        else this.options.saveMissingTo === "all" ? ue = this.languageUtils.toResolveHierarchy(t.lng || this.language) : ue.push(t.lng || this.language);
        const Be = (ae, ye, qe) => {
          var Kt;
          const xt = F && qe !== u ? qe : K;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ae, c, ye, xt, B, t) : (Kt = this.backendConnector) != null && Kt.saveMissing && this.backendConnector.saveMissing(ae, c, ye, xt, B, t), this.emit("missingKey", ae, c, ye, u);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? ue.forEach((ae) => {
          const ye = this.pluralResolver.getSuffixes(ae, t);
          ce && t[`defaultValue${this.options.pluralSeparator}zero`] && ye.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ye.push(`${this.options.pluralSeparator}zero`), ye.forEach((qe) => {
            Be([ae], o + qe, t[`defaultValue${qe}`] || X);
          });
        }) : Be(ue, o, X));
      }
      u = this.extendTranslation(u, e, t, d, r), z && u === o && this.options.appendNamespaceToMissingKey && (u = `${c}:${o}`), (z || G) && this.options.parseMissingKeyHandler && (u = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${o}` : o, G ? u : void 0));
    }
    return s ? (d.res = u, d.usedParams = this.getUsedParamsDetails(t), d) : u;
  }
  extendTranslation(e, t, r, s, a) {
    var l, f;
    var o = this;
    if ((l = this.i18nFormat) != null && l.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const d = P(e) && (((f = r == null ? void 0 : r.interpolation) == null ? void 0 : f.skipOnVariables) !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (d) {
        const m = e.match(this.interpolator.nestingRegexp);
        u = m && m.length;
      }
      let g = r.replace && !P(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (g = {
        ...this.options.interpolation.defaultVariables,
        ...g
      }), e = this.interpolator.interpolate(e, g, r.lng || this.language || s.usedLng, r), d) {
        const m = e.match(this.interpolator.nestingRegexp), b = m && m.length;
        u < b && (r.nest = !1);
      }
      !r.lng && s && s.res && (r.lng = this.language || s.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var m = arguments.length, b = new Array(m), y = 0; y < m; y++)
          b[y] = arguments[y];
        return (a == null ? void 0 : a[0]) === b[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${b[0]} in key: ${t[0]}`), null) : o.translate(...b, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const i = r.postProcess || this.options.postProcess, c = P(i) ? [i] : i;
    return e != null && (c != null && c.length) && r.applyPostProcessor !== !1 && (e = ma.handle(c, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, a, o, i;
    return P(e) && (e = [e]), e.forEach((c) => {
      if (this.isValidLookup(r)) return;
      const l = this.extractFromKey(c, t), f = l.key;
      s = f;
      let d = l.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const u = t.count !== void 0 && !P(t.count), g = u && !t.ordinal && t.count === 0, m = t.context !== void 0 && (P(t.context) || typeof t.context == "number") && t.context !== "", b = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((y) => {
        var R, k;
        this.isValidLookup(r) || (i = y, !Gr[`${b[0]}-${y}`] && ((R = this.utils) != null && R.hasLoadedNamespace) && !((k = this.utils) != null && k.hasLoadedNamespace(i)) && (Gr[`${b[0]}-${y}`] = !0, this.logger.warn(`key "${s}" for languages "${b.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((F) => {
          var ce;
          if (this.isValidLookup(r)) return;
          o = F;
          const J = [f];
          if ((ce = this.i18nFormat) != null && ce.addLookupKeys)
            this.i18nFormat.addLookupKeys(J, f, F, y, t);
          else {
            let X;
            u && (X = this.pluralResolver.getSuffix(F, t.count, t));
            const D = `${this.options.pluralSeparator}zero`, ee = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (u && (J.push(f + X), t.ordinal && X.indexOf(ee) === 0 && J.push(f + X.replace(ee, this.options.pluralSeparator)), g && J.push(f + D)), m) {
              const W = `${f}${this.options.contextSeparator}${t.context}`;
              J.push(W), u && (J.push(W + X), t.ordinal && X.indexOf(ee) === 0 && J.push(W + X.replace(ee, this.options.pluralSeparator)), g && J.push(W + D));
            }
          }
          let H;
          for (; H = J.pop(); )
            this.isValidLookup(r) || (a = H, r = this.getResource(F, y, H, t));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: a,
      usedLng: o,
      usedNS: i
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    var a;
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return (a = this.i18nFormat) != null && a.getResource ? this.i18nFormat.getResource(e, t, r, s) : this.resourceStore.getResource(e, t, r, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !P(e.replace);
    let s = r ? e.replace : e;
    if (r && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const a of t)
        delete s[a];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
class Yr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ae.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = vn(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = vn(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (P(e) && e.indexOf("-") > -1) {
      let t;
      try {
        t = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return t && this.options.lowerCaseLng && (t = t.toLowerCase()), t || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((r) => {
      if (t) return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t) return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s)) return t = s;
      t = this.options.supportedLngs.find((a) => {
        if (a === s) return a;
        if (!(a.indexOf("-") < 0 && s.indexOf("-") < 0) && (a.indexOf("-") > 0 && s.indexOf("-") < 0 && a.substring(0, a.indexOf("-")) === s || a.indexOf(s) === 0 && s.length > 1))
          return a;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), P(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], a = (o) => {
      o && (this.isSupportedCode(o) ? s.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return P(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(e))) : P(e) && a(this.formatLanguageCode(e)), r.forEach((o) => {
      s.indexOf(o) < 0 && a(this.formatLanguageCode(o));
    }), s;
  }
}
const Jr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Qr = {
  select: (n) => n === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class Yc {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Ae.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = vn(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", a = JSON.stringify({
      cleanedCode: r,
      type: s
    });
    if (a in this.pluralRulesCache)
      return this.pluralRulesCache[a];
    let o;
    try {
      o = new Intl.PluralRules(r, {
        type: s
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Qr;
      if (!e.match(/-|_/)) return Qr;
      const c = this.languageUtils.getLanguagePartFromCode(e);
      o = this.getRule(c, t);
    }
    return this.pluralRulesCache[a] = o, o;
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(e, t);
    return r || (r = this.getRule("dev", t)), (r == null ? void 0 : r.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(e, t);
    return r || (r = this.getRule("dev", t)), r ? r.resolvedOptions().pluralCategories.sort((s, a) => Jr[s] - Jr[a]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, r);
    return s ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", t, r));
  }
}
const Xr = function(n, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, a = Uc(n, e, t);
  return !a && s && P(t) && (a = Kn(n, t, r), a === void 0 && (a = Kn(e, t, r))), a;
}, In = (n) => n.replace(/\$/g, "$$$$");
class Jc {
  constructor() {
    var t;
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ae.create("interpolator"), this.options = e, this.format = ((t = e == null ? void 0 : e.interpolation) == null ? void 0 : t.format) || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: s,
      prefix: a,
      prefixEscaped: o,
      suffix: i,
      suffixEscaped: c,
      formatSeparator: l,
      unescapeSuffix: f,
      unescapePrefix: d,
      nestingPrefix: u,
      nestingPrefixEscaped: g,
      nestingSuffix: m,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: y,
      maxReplaces: R,
      alwaysFormat: k
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Bc, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = a ? ut(a) : o || "{{", this.suffix = i ? ut(i) : c || "}}", this.formatSeparator = l || ",", this.unescapePrefix = f ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : f || "", this.nestingPrefix = u ? ut(u) : g || ut("$t("), this.nestingSuffix = m ? ut(m) : b || ut(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = R || 1e3, this.alwaysFormat = k !== void 0 ? k : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => (t == null ? void 0 : t.source) === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, s) {
    var g;
    let a, o, i;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, l = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const k = Xr(t, c, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(k, void 0, r, {
          ...s,
          ...t,
          interpolationkey: m
        }) : k;
      }
      const b = m.split(this.formatSeparator), y = b.shift().trim(), R = b.join(this.formatSeparator).trim();
      return this.format(Xr(t, c, y, this.options.keySeparator, this.options.ignoreJSONStructure), R, r, {
        ...s,
        ...t,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const f = (s == null ? void 0 : s.missingInterpolationHandler) || this.options.missingInterpolationHandler, d = ((g = s == null ? void 0 : s.interpolation) == null ? void 0 : g.skipOnVariables) !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => In(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? In(this.escape(m)) : In(m)
    }].forEach((m) => {
      for (i = 0; a = m.regex.exec(e); ) {
        const b = a[1].trim();
        if (o = l(b), o === void 0)
          if (typeof f == "function") {
            const R = f(e, a, s);
            o = P(R) ? R : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, b))
            o = "";
          else if (d) {
            o = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${b} for interpolating ${e}`), o = "";
        else !P(o) && !this.useRawValueToEscape && (o = Zr(o));
        const y = m.safeValue(o);
        if (e = e.replace(a[0], y), d ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= a[0].length) : m.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, a, o;
    const i = (c, l) => {
      const f = this.nestingOptionsSeparator;
      if (c.indexOf(f) < 0) return c;
      const d = c.split(new RegExp(`${f}[ ]*{`));
      let u = `{${d[1]}`;
      c = d[0], u = this.interpolate(u, o);
      const g = u.match(/'/g), m = u.match(/"/g);
      (((g == null ? void 0 : g.length) ?? 0) % 2 === 0 && !m || m.length % 2 !== 0) && (u = u.replace(/'/g, '"'));
      try {
        o = JSON.parse(u), l && (o = {
          ...l,
          ...o
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, b), `${c}${f}${u}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, c;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let c = [];
      o = {
        ...r
      }, o = o.replace && !P(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let l = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const f = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = f.shift(), c = f, l = !0;
      }
      if (a = t(i.call(this, s[1].trim(), o), o), a && s[0] === e && !P(a)) return a;
      P(a) || (a = Zr(a)), a || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), a = ""), l && (a = c.reduce((f, d) => this.format(f, d, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), a.trim())), e = e.replace(s[0], a), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Qc = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const r = n.split("(");
    e = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((o) => {
      if (o) {
        const [i, ...c] = o.split(":"), l = c.join(":").trim().replace(/^'+|'+$/g, ""), f = i.trim();
        t[f] || (t[f] = l), l === "false" && (t[f] = !1), l === "true" && (t[f] = !0), isNaN(l) || (t[f] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, dt = (n) => {
  const e = {};
  return (t, r, s) => {
    let a = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (a = {
      ...a,
      [s.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(a);
    let i = e[o];
    return i || (i = n(vn(r), s), e[o] = i), i(t);
  };
};
class Xc {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ae.create("formatter"), this.options = e, this.formats = {
      number: dt((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r
        });
        return (a) => s.format(a);
      }),
      currency: dt((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (a) => s.format(a);
      }),
      datetime: dt((t, r) => {
        const s = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (a) => s.format(a);
      }),
      relativetime: dt((t, r) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (a) => s.format(a, r.range || "day");
      }),
      list: dt((t, r) => {
        const s = new Intl.ListFormat(t, {
          ...r
        });
        return (a) => s.format(a);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = dt(t);
  }
  format(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = t.split(this.formatSeparator);
    if (a.length > 1 && a[0].indexOf("(") > 1 && a[0].indexOf(")") < 0 && a.find((i) => i.indexOf(")") > -1)) {
      const i = a.findIndex((c) => c.indexOf(")") > -1);
      a[0] = [a[0], ...a.splice(1, i)].join(this.formatSeparator);
    }
    return a.reduce((i, c) => {
      var d;
      const {
        formatName: l,
        formatOptions: f
      } = Qc(c);
      if (this.formats[l]) {
        let u = i;
        try {
          const g = ((d = s == null ? void 0 : s.formatParams) == null ? void 0 : d[s.interpolationkey]) || {}, m = g.locale || g.lng || s.locale || s.lng || r;
          u = this.formats[l](i, m, {
            ...f,
            ...s,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, e);
  }
}
const eu = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class tu extends Nn {
  constructor(e, t, r) {
    var a, o;
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = Ae.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], (o = (a = this.backend) == null ? void 0 : a.init) == null || o.call(a, r, s.backend, s);
  }
  queueLoad(e, t, r, s) {
    const a = {}, o = {}, i = {}, c = {};
    return e.forEach((l) => {
      let f = !0;
      t.forEach((d) => {
        const u = `${l}|${d}`;
        !r.reload && this.store.hasResourceBundle(l, d) ? this.state[u] = 2 : this.state[u] < 0 || (this.state[u] === 1 ? o[u] === void 0 && (o[u] = !0) : (this.state[u] = 1, f = !1, o[u] === void 0 && (o[u] = !0), a[u] === void 0 && (a[u] = !0), c[d] === void 0 && (c[d] = !0)));
      }), f || (i[l] = !0);
    }), (Object.keys(a).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(e, t, r) {
    const s = e.split("|"), a = s[0], o = s[1];
    t && this.emit("failedLoading", a, o, t), !t && r && this.store.addResourceBundle(a, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && r && (this.state[e] = 0);
    const i = {};
    this.queue.forEach((c) => {
      Mc(c.loaded, [a], o), eu(c, e), t && c.errors.push(t), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((l) => {
        i[l] || (i[l] = {});
        const f = c.loaded[l];
        f.length && f.forEach((d) => {
          i[l][d] === void 0 && (i[l][d] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((c) => !c.done);
  }
  read(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: s,
        wait: a,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const i = (l, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (l && f && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, s + 1, a * 2, o);
        }, a);
        return;
      }
      o(l, f);
    }, c = this.backend[r].bind(this.backend);
    if (c.length === 2) {
      try {
        const l = c(e, t);
        l && typeof l.then == "function" ? l.then((f) => i(null, f)).catch(i) : i(null, l);
      } catch (l) {
        i(l);
      }
      return;
    }
    return c(e, t, i);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    P(e) && (e = this.languageUtils.toResolveHierarchy(e)), P(t) && (t = [t]);
    const a = this.queueLoad(e, t, r, s);
    if (!a.toLoad.length)
      return a.pending.length || s(), null;
    a.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), s = r[0], a = r[1];
    this.read(s, a, "read", void 0, void 0, (o, i) => {
      o && this.logger.warn(`${t}loading namespace ${a} for language ${s} failed`, o), !o && i && this.logger.log(`${t}loaded namespace ${a} for language ${s}`, i), this.loaded(e, o, i);
    });
  }
  saveMissing(e, t, r, s, a) {
    var c, l, f, d, u;
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, i = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if ((l = (c = this.services) == null ? void 0 : c.utils) != null && l.hasLoadedNamespace && !((d = (f = this.services) == null ? void 0 : f.utils) != null && d.hasLoadedNamespace(t))) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if ((u = this.backend) != null && u.create) {
        const g = {
          ...o,
          isUpdate: a
        }, m = this.backend.create.bind(this.backend);
        if (m.length < 6)
          try {
            let b;
            m.length === 5 ? b = m(e, t, r, s, g) : b = m(e, t, r, s), b && typeof b.then == "function" ? b.then((y) => i(null, y)).catch(i) : i(null, b);
          } catch (b) {
            i(b);
          }
        else
          m(e, t, r, s, i, g);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, s);
    }
  }
}
const es = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), P(n[1]) && (e.defaultValue = n[1]), P(n[2]) && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((r) => {
        e[r] = t[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), ts = (n) => {
  var e, t;
  return P(n.ns) && (n.ns = [n.ns]), P(n.fallbackLng) && (n.fallbackLng = [n.fallbackLng]), P(n.fallbackNS) && (n.fallbackNS = [n.fallbackNS]), ((t = (e = n.supportedLngs) == null ? void 0 : e.indexOf) == null ? void 0 : t.call(e, "cimode")) < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), typeof n.initImmediate == "boolean" && (n.initAsync = n.initImmediate), n;
}, en = () => {
}, nu = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class qt extends Nn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ts(e), this.services = {}, this.logger = Ae, this.modules = {
      external: []
    }, nu(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), t.defaultNS == null && t.ns && (P(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = es();
    this.options = {
      ...s,
      ...this.options,
      ...ts(t)
    }, this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const a = (f) => f ? typeof f == "function" ? new f() : f : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ae.init(a(this.modules.logger), this.options) : Ae.init(null, this.options);
      let f;
      this.modules.formatter ? f = this.modules.formatter : f = Xc;
      const d = new Yr(this.options);
      this.store = new Wr(this.options.resources, this.options);
      const u = this.services;
      u.logger = Ae, u.resourceStore = this.store, u.languageUtils = d, u.pluralResolver = new Yc(d, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), f && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (u.formatter = a(f), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new Jc(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new tu(a(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(g) {
        for (var m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          b[y - 1] = arguments[y];
        e.emit(g, ...b);
      }), this.modules.languageDetector && (u.languageDetector = a(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = a(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new wn(this.services, this.options), this.translator.on("*", function(g) {
        for (var m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          b[y - 1] = arguments[y];
        e.emit(g, ...b);
      }), this.modules.external.forEach((g) => {
        g.init && g.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = en), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      f.length > 0 && f[0] !== "dev" && (this.options.lng = f[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((f) => {
      this[f] = function() {
        return e.store[f](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((f) => {
      this[f] = function() {
        return e.store[f](...arguments), e;
      };
    });
    const c = $t(), l = () => {
      const f = (d, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), c.resolve(u), r(d, u);
      };
      if (this.languages && !this.isInitialized) return f(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, f);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), c;
  }
  loadResources(e) {
    var a, o;
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : en;
    const s = P(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if ((s == null ? void 0 : s.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const i = [], c = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((d) => {
          d !== "cimode" && i.indexOf(d) < 0 && i.push(d);
        });
      };
      s ? c(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((f) => c(f)), (o = (a = this.options.preload) == null ? void 0 : a.forEach) == null || o.call(a, (l) => c(l)), this.services.backendConnector.load(i, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(l);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const s = $t();
    return typeof e == "function" && (r = e, e = void 0), typeof t == "function" && (r = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), r || (r = en), this.services.backendConnector.reload(e, t, (a) => {
      s.resolve(), r(a);
    }), s;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && ma.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const s = $t();
    this.emit("languageChanging", e);
    const a = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, o = (c, l) => {
      l ? (a(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), t && t(c, function() {
        return r.t(...arguments);
      });
    }, i = (c) => {
      var f, d;
      !e && !c && this.services.languageDetector && (c = []);
      const l = P(c) ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      l && (this.language || a(l), this.translator.language || this.translator.changeLanguage(l), (d = (f = this.services.languageDetector) == null ? void 0 : f.cacheUserLanguage) == null || d.call(f, l)), this.loadResources(l, (u) => {
        o(u, l);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(e), s;
  }
  getFixedT(e, t, r) {
    var s = this;
    const a = function(o, i) {
      let c;
      if (typeof i != "object") {
        for (var l = arguments.length, f = new Array(l > 2 ? l - 2 : 0), d = 2; d < l; d++)
          f[d - 2] = arguments[d];
        c = s.options.overloadTranslationOptionHandler([o, i].concat(f));
      } else
        c = {
          ...i
        };
      c.lng = c.lng || a.lng, c.lngs = c.lngs || a.lngs, c.ns = c.ns || a.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || r || a.keyPrefix);
      const u = s.options.keySeparator || ".";
      let g;
      return c.keyPrefix && Array.isArray(o) ? g = o.map((m) => `${c.keyPrefix}${u}${m}`) : g = c.keyPrefix ? `${c.keyPrefix}${u}${o}` : o, s.t(g, c);
    };
    return P(e) ? a.lng = e : a.lngs = e, a.ns = t, a.keyPrefix = r, a;
  }
  t() {
    var s;
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return (s = this.translator) == null ? void 0 : s.translate(...t);
  }
  exists() {
    var s;
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return (s = this.translator) == null ? void 0 : s.exists(...t);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const o = (i, c) => {
      const l = this.services.backendConnector.state[`${i}|${c}`];
      return l === -1 || l === 0 || l === 2;
    };
    if (t.precheck) {
      const i = t.precheck(this, o);
      if (i !== void 0) return i;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, e) && (!s || o(a, e)));
  }
  loadNamespaces(e, t) {
    const r = $t();
    return this.options.ns ? (P(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), t && t(s);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = $t();
    P(e) && (e = [e]);
    const s = this.options.preload || [], a = e.filter((o) => s.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return a.length ? (this.options.preload = s.concat(a), this.loadResources((o) => {
      r.resolve(), t && t(o);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    var s, a;
    if (e || (e = this.resolvedLanguage || (((s = this.languages) == null ? void 0 : s.length) > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = ((a = this.services) == null ? void 0 : a.languageUtils) || new Yr(es());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new qt(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : en;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, a = new qt(s);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (a.logger = a.logger.clone(e)), ["store", "services", "language"].forEach((i) => {
      a[i] = this[i];
    }), a.services = {
      ...this.services
    }, a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, r) {
      const i = Object.keys(this.store.data).reduce((c, l) => (c[l] = {
        ...this.store.data[l]
      }, Object.keys(c[l]).reduce((f, d) => (f[d] = {
        ...c[l][d]
      }, f), {})), {});
      a.store = new Wr(i, s), a.services.resourceStore = a.store;
    }
    return a.translator = new wn(a.services, s), a.translator.on("*", function(i) {
      for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++)
        l[f - 1] = arguments[f];
      a.emit(i, ...l);
    }), a.init(s, t), a.translator.options = s, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const _e = qt.createInstance();
_e.createInstance = qt.createInstance;
const ru = _e.createInstance;
_e.dir;
_e.init;
_e.loadResources;
_e.reloadResources;
_e.use;
_e.changeLanguage;
_e.getFixedT;
_e.t;
_e.exists;
_e.setDefaultNamespace;
_e.hasLoadedNamespace;
_e.loadNamespaces;
_e.loadLanguages;
const su = "Studio", au = "{{count}} soveværelse", ou = "{{count}} soveværelser", iu = "", lu = "{{count}} seng", cu = "{{count}} senge", uu = "", du = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: su,
  bedroomsNumbers_one: au,
  bedroomsNumbers_other: ou,
  beds_zero: iu,
  beds_one: lu,
  beds_other: cu,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.collection.gotit": "Forstået",
  no_result: uu
}, fu = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", hu = "Dobbelt booking (via en anden platform)", gu = "Familieproblemer", pu = "Helbredsproblemer", mu = "Skader i hjemmet", _u = "Flytning", bu = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", vu = "Andre", yu = "Transportproblemer", wu = "Tillidsproblem", xu = "Arbejdsrelateret", ku = "Du er nødt til at indtaste en årsag", Su = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her.",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  pre_approval_modal_expiration_description: fu,
  reasons_for_cancellation_double_booking_rental: hu,
  reasons_for_cancellation_family_issues: gu,
  reasons_for_cancellation_health_issues: pu,
  reasons_for_cancellation_home_damage: mu,
  reasons_for_cancellation_moving: _u,
  reasons_for_cancellation_needed: bu,
  reasons_for_cancellation_other: vu,
  reasons_for_cancellation_transportation_issues: yu,
  reasons_for_cancellation_trust_issues: wu,
  reasons_for_cancellation_work_related: xu,
  reasons_other_comment_needed: ku
}, $u = "Studio", Nu = "{{count}} schlafzimmer", Ou = "{{count}} schlafzimmer", Tu = "", Eu = "{{count}} Bett", Cu = "{{count}} Betten", Ru = "", Au = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: $u,
  bedroomsNumbers_one: Nu,
  bedroomsNumbers_other: Ou,
  beds_zero: Tu,
  beds_one: Eu,
  beds_other: Cu,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.collection.gotit": "Verstanden!",
  no_result: Ru
}, zu = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", Du = "Doppelbuchung (über eine andere Plattform)", Lu = "Familiäre Gründe", ju = "Gesundheitliche Probleme", Pu = "Schäden an der Unterkunft", Iu = "Umzug", Vu = "Sie müssten bitte die Gründe für Ihre Annullierung angeben.", Fu = "Andere", Mu = "Probleme bei der An-/Abreise", Uu = "Vertrauensprobleme", Zu = "Arbeitsbedingte Gründe", Bu = "Sie müssen einen Grund angeben", qu = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "Beachten Sie, dass die Stornierung Ihres Haustauschs negative Auswirkungen auf Ihre Tauschpartner haben könnte, die möglicherweise bereits Reisepläne gemacht haben!",
  "cancellation-page.warning-step.second-warning": "Wichtig: Zu viele ungerechtfertigte Stornierungen können dazu führen, dass Ihr Konto als Gastgeber*in offline gestellt wird. Als Gast*in können Ihnen möglicherweise nicht alle Ihre GuestPoints zurückerstattet werden.",
  pre_approval_modal_expiration_description: zu,
  reasons_for_cancellation_double_booking_rental: Du,
  reasons_for_cancellation_family_issues: Lu,
  reasons_for_cancellation_health_issues: ju,
  reasons_for_cancellation_home_damage: Pu,
  reasons_for_cancellation_moving: Iu,
  reasons_for_cancellation_needed: Vu,
  reasons_for_cancellation_other: Fu,
  reasons_for_cancellation_transportation_issues: Mu,
  reasons_for_cancellation_trust_issues: Uu,
  reasons_for_cancellation_work_related: Zu,
  reasons_other_comment_needed: Bu
}, Hu = "Studio", Wu = "{{count}} bedroom", Gu = "{{count}} bedrooms", Ku = "", Yu = "{{count}} bed", Ju = "{{count}} beds", Qu = "No result", Xu = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: Hu,
  bedroomsNumbers_one: Wu,
  bedroomsNumbers_other: Gu,
  beds_zero: Ku,
  beds_one: Yu,
  beds_other: Ju,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.collection.gotit": "Got it!",
  no_result: Qu
}, ed = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", td = "Double booking (via another platform)", nd = "Family issue", rd = "Health issue", sd = "Home damage", ad = "Moving home", od = "You need to indicate the reasons for your cancellation.", id = "Other", ld = "Transport issue", cd = "Trust issue", ud = "Work related", dd = "You need to enter a reason", fd = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: ed,
  reasons_for_cancellation_double_booking_rental: td,
  reasons_for_cancellation_family_issues: nd,
  reasons_for_cancellation_health_issues: rd,
  reasons_for_cancellation_home_damage: sd,
  reasons_for_cancellation_moving: ad,
  reasons_for_cancellation_needed: od,
  reasons_for_cancellation_other: id,
  reasons_for_cancellation_transportation_issues: ld,
  reasons_for_cancellation_trust_issues: cd,
  reasons_for_cancellation_work_related: ud,
  reasons_other_comment_needed: dd
}, hd = "Studio", gd = "{{count}} bedroom", pd = "{{count}} bedrooms", md = "", _d = "{{count}} bed", bd = "{{count}} beds", vd = "", yd = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: hd,
  bedroomsNumbers_one: gd,
  bedroomsNumbers_other: pd,
  beds_zero: md,
  beds_one: _d,
  beds_other: bd,
  "button.free-signup": "Sign up for free",
  "button.validate": "",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "",
  "errors.unable_to_submit.title": "",
  "global.collection.gotit": "",
  no_result: vd
}, wd = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", xd = "Double booking (via another platform)", kd = "Family issue", Sd = "Health issue", $d = "Home damage", Nd = "Moving home", Od = "", Td = "", Ed = "Transport issue", Cd = "Trust issue", Rd = "Work related", Ad = "", zd = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: wd,
  reasons_for_cancellation_double_booking_rental: xd,
  reasons_for_cancellation_family_issues: kd,
  reasons_for_cancellation_health_issues: Sd,
  reasons_for_cancellation_home_damage: $d,
  reasons_for_cancellation_moving: Nd,
  reasons_for_cancellation_needed: Od,
  reasons_for_cancellation_other: Td,
  reasons_for_cancellation_transportation_issues: Ed,
  reasons_for_cancellation_trust_issues: Cd,
  reasons_for_cancellation_work_related: Rd,
  reasons_other_comment_needed: Ad
}, Dd = "Estudio", Ld = "{{count}} dormitorio", jd = "{{count}} dormitorios", Pd = "", Id = "{{count}} cama", Vd = "{{count}} camas", Fd = "", Md = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: Dd,
  bedroomsNumbers_one: Ld,
  bedroomsNumbers_other: jd,
  beds_zero: Pd,
  beds_one: Id,
  beds_other: Vd,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.collection.gotit": "",
  no_result: Fd
}, Ud = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", Zd = "Reserva doble (otra plataforma)", Bd = "Asuntos familiares", qd = "Temas de salud", Hd = "Daños en la casa", Wd = "Mudanza", Gd = "Por favor, indica las razones de la cancelación", Kd = "Otro", Yd = "Problemas con el transporte", Jd = "Temas de confianza", Qd = "Asuntos laborales", Xd = "Debes introducir un motivo", ef = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "Debes introducir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "No olvides que cancelar el intercambio puede afectar a tus compañeros de intercambio, que seguramente han hecho planes.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones injustificadas por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  pre_approval_modal_expiration_description: Ud,
  reasons_for_cancellation_double_booking_rental: Zd,
  reasons_for_cancellation_family_issues: Bd,
  reasons_for_cancellation_health_issues: qd,
  reasons_for_cancellation_home_damage: Hd,
  reasons_for_cancellation_moving: Wd,
  reasons_for_cancellation_needed: Gd,
  reasons_for_cancellation_other: Kd,
  reasons_for_cancellation_transportation_issues: Yd,
  reasons_for_cancellation_trust_issues: Jd,
  reasons_for_cancellation_work_related: Qd,
  reasons_other_comment_needed: Xd
}, tf = "Studio", nf = "{{count}} chambre", rf = "{{count}} chambres", sf = "", af = "{{count}} lit", of = "{{count}} lits", lf = "", cf = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: tf,
  bedroomsNumbers_one: nf,
  bedroomsNumbers_other: rf,
  beds_zero: sf,
  beds_one: af,
  beds_other: of,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.collection.gotit": "J'ai compris !",
  no_result: lf
}, uf = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", df = "Double réservation (via une autre plateforme)", ff = "Imprévu familial", hf = "Problème de santé", gf = "Dégâts à mon domicile", pf = "Déménagement", mf = "Vous devez indiquer les raisons de votre annulation.", _f = "Autre", bf = "Problème de transport", vf = "Problème de confiance", yf = "Imprévu professionnel", wf = "Vous devez saisir un motif", xf = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange, qui a peut-être déjà planifié son voyage !",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  pre_approval_modal_expiration_description: uf,
  reasons_for_cancellation_double_booking_rental: df,
  reasons_for_cancellation_family_issues: ff,
  reasons_for_cancellation_health_issues: hf,
  reasons_for_cancellation_home_damage: gf,
  reasons_for_cancellation_moving: pf,
  reasons_for_cancellation_needed: mf,
  reasons_for_cancellation_other: _f,
  reasons_for_cancellation_transportation_issues: bf,
  reasons_for_cancellation_trust_issues: vf,
  reasons_for_cancellation_work_related: yf,
  reasons_other_comment_needed: wf
}, kf = "Studio", Sf = "{{count}} soba", $f = "{{count}} sobe", Nf = "{{count}} sobe", Of = "", Tf = "{{count}} krevet", Ef = "{{count}} kreveti", Cf = "{{count}} kreveti", Rf = "", Af = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: kf,
  bedroomsNumbers_one: Sf,
  bedroomsNumbers_few: $f,
  bedroomsNumbers_other: Nf,
  beds_zero: Of,
  beds_one: Tf,
  beds_few: Ef,
  beds_other: Cf,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.collection.gotit": "U redu!",
  no_result: Rf
}, zf = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", Df = "Dvostruka rezervacija (druga platforma)", Lf = "Obiteljski problemi", jf = "Zdravstveni problemi", Pf = "Oštećenje doma", If = "Preseljenje", Vf = "Morate navesti razloge otkazivanja", Ff = "Ostalo", Mf = "Problemi s prijevozom", Uf = "Nepovjerenje", Zf = "Poslovni problemi", Bf = "Trebate unijeti razlog", qf = {
  "cancellation-page.cancel-exchange": "Otkažite zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite svoju zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "Vodite računa o tome da otkazivanje zamjene može negativno utjecati na Vašeg partnera za zamjenu koji je već možda napravio planove za putovanje!",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš dom može biti uklonjen s interneta. A kao gost, možda nećete dobiti natrag svoje GuestPoints.",
  pre_approval_modal_expiration_description: zf,
  reasons_for_cancellation_double_booking_rental: Df,
  reasons_for_cancellation_family_issues: Lf,
  reasons_for_cancellation_health_issues: jf,
  reasons_for_cancellation_home_damage: Pf,
  reasons_for_cancellation_moving: If,
  reasons_for_cancellation_needed: Vf,
  reasons_for_cancellation_other: Ff,
  reasons_for_cancellation_transportation_issues: Mf,
  reasons_for_cancellation_trust_issues: Uf,
  reasons_for_cancellation_work_related: Zf,
  reasons_other_comment_needed: Bf
}, Hf = "Monolocale", Wf = "{{count}} camera da letto", Gf = "{{count}} camere da letto", Kf = "", Yf = "{{count}} letto", Jf = "{{count}} letti", Qf = "", Xf = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: Hf,
  bedroomsNumbers_one: Wf,
  bedroomsNumbers_other: Gf,
  beds_zero: Kf,
  beds_one: Yf,
  beds_other: Jf,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.collection.gotit": "Ho capito!",
  no_result: Qf
}, eh = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", th = "Doppia prenotazione (con un'altra piattaforma)", nh = "Ragioni familiari", rh = "Motivi di salute", sh = "Danni alla proprietà", ah = "Trasferimento", oh = "È necessario indicare i motivi per la cancellazione.", ih = "Altro", lh = "Problemi di trasporto", ch = "Problemi di fiducia", uh = "Motivi legati al lavoro", dh = "È necessario inserire un motivo", fh = {
  "cancellation-page.cancel-exchange": "Annulla lo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni il mio scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "Ricorda che annullare il tuo scambio può avere un impatto negativo sul tuo partner di scambio, che potrebbe già aver pianificato il viaggio!",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. E come ospite, potresti non recuperare tutti i tuoi GuestPoints.",
  pre_approval_modal_expiration_description: eh,
  reasons_for_cancellation_double_booking_rental: th,
  reasons_for_cancellation_family_issues: nh,
  reasons_for_cancellation_health_issues: rh,
  reasons_for_cancellation_home_damage: sh,
  reasons_for_cancellation_moving: ah,
  reasons_for_cancellation_needed: oh,
  reasons_for_cancellation_other: ih,
  reasons_for_cancellation_transportation_issues: lh,
  reasons_for_cancellation_trust_issues: ch,
  reasons_for_cancellation_work_related: uh,
  reasons_other_comment_needed: dh
}, hh = "Studio", gh = "{{count}} soverom", ph = "{{count}} soverom", mh = "", _h = "{{count}} seng", bh = "{{count}} senger", vh = "", yh = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: hh,
  bedroomsNumbers_one: gh,
  bedroomsNumbers_other: ph,
  beds_zero: mh,
  beds_one: _h,
  beds_other: bh,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.collection.gotit": "",
  no_result: vh
}, wh = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", xh = "Dobbelbooking (via en annen plattform)", kh = "Famileproblemer", Sh = "Helseproblemer", $h = "Skade på boligen", Nh = "Flytting", Oh = "Du må angi årsakene til avbestillingen.", Th = "Annet", Eh = "Transportproblemer", Ch = "Tillitsbrudd", Rh = "Arbeidsrelatert", Ah = "Du må oppgi en grunn", zh = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  pre_approval_modal_expiration_description: wh,
  reasons_for_cancellation_double_booking_rental: xh,
  reasons_for_cancellation_family_issues: kh,
  reasons_for_cancellation_health_issues: Sh,
  reasons_for_cancellation_home_damage: $h,
  reasons_for_cancellation_moving: Nh,
  reasons_for_cancellation_needed: Oh,
  reasons_for_cancellation_other: Th,
  reasons_for_cancellation_transportation_issues: Eh,
  reasons_for_cancellation_trust_issues: Ch,
  reasons_for_cancellation_work_related: Rh,
  reasons_other_comment_needed: Ah
}, Dh = "Studio", Lh = "{{count}} slaapkamer", jh = "{{count}} slaapkamers", Ph = "", Ih = "{{count}} bed", Vh = "{{count}} bedden", Fh = "Geen resultaat", Mh = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: Dh,
  bedroomsNumbers_one: Lh,
  bedroomsNumbers_other: jh,
  beds_zero: Ph,
  beds_one: Ih,
  beds_other: Vh,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.collection.gotit": "Begrepen!",
  no_result: Fh
}, Uh = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", Zh = "Dubbele boeking (via een ander platform)", Bh = "Familiale redenen", qh = "Gezondheidsproblemen", Hh = "Schade aan het huis", Wh = "Verhuis", Gh = "U dient aan te geven in de redenen voor uw annulering.", Kh = "Andere", Yh = "Problemen met het transport", Jh = "Vertrouwenskwestie", Qh = "Werkgerelateerde redenen", Xh = "Je moet een reden opgeven", eg = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "Vergeet niet dat het annuleren van je uitwisseling negatieve gevolgen kan hebben voor je uitwisselingspartner, die misschien al reisplannen heeft gemaakt!",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  pre_approval_modal_expiration_description: Uh,
  reasons_for_cancellation_double_booking_rental: Zh,
  reasons_for_cancellation_family_issues: Bh,
  reasons_for_cancellation_health_issues: qh,
  reasons_for_cancellation_home_damage: Hh,
  reasons_for_cancellation_moving: Wh,
  reasons_for_cancellation_needed: Gh,
  reasons_for_cancellation_other: Kh,
  reasons_for_cancellation_transportation_issues: Yh,
  reasons_for_cancellation_trust_issues: Jh,
  reasons_for_cancellation_work_related: Qh,
  reasons_other_comment_needed: Xh
}, tg = "Studio", ng = "{{count}} quarto", rg = "{{count}} quartos", sg = "", ag = "{{count}} cama", og = "{{count}} camas", ig = "", lg = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: tg,
  bedroomsNumbers_one: ng,
  bedroomsNumbers_other: rg,
  beds_zero: sg,
  beds_one: ag,
  beds_other: og,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.collection.gotit": "",
  no_result: ig
}, cg = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", ug = "Reserva dupla (outra plataforma)", dg = "Motivos familiares", fg = "Motivos de saúde", hg = "Danos na propriedade", gg = "Mudanças", pg = "Você precisa indicar os motivos do cancelamento.", mg = "Outro", _g = "Problemas de transporte", bg = "Problemas de confiança", vg = "Motivos laborais", yg = "É obrigatório introduzir um motivo", wg = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  pre_approval_modal_expiration_description: cg,
  reasons_for_cancellation_double_booking_rental: ug,
  reasons_for_cancellation_family_issues: dg,
  reasons_for_cancellation_health_issues: fg,
  reasons_for_cancellation_home_damage: hg,
  reasons_for_cancellation_moving: gg,
  reasons_for_cancellation_needed: pg,
  reasons_for_cancellation_other: mg,
  reasons_for_cancellation_transportation_issues: _g,
  reasons_for_cancellation_trust_issues: bg,
  reasons_for_cancellation_work_related: vg,
  reasons_other_comment_needed: yg
}, xg = "Studio", kg = "{{count}} sovrum", Sg = "{{count}} sovrum", $g = "", Ng = "{{count}} säng", Og = "{{count}} sängar", Tg = "", Eg = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: xg,
  bedroomsNumbers_one: kg,
  bedroomsNumbers_other: Sg,
  beds_zero: $g,
  beds_one: Ng,
  beds_other: Og,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.collection.gotit": "Uppfattat!",
  no_result: Tg
}, Cg = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", Rg = "Dubbelbokning (annan plattform)", Ag = "Familjeproblem", zg = "Hälsoproblem", Dg = "Skada i hemmet", Lg = "Flytt", jg = "Du måste ange orsaken till din avbokning.", Pg = "Övrigt", Ig = "Transportproblem", Vg = "Bristande förtroende", Fg = "Arbetsrelaterat", Mg = "Du behöver ange en anledning", Ug = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudanledningen till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Ange anledningen till din avbokning här.",
  "cancellation-page.reason_step.error": "Du behöver ange en anledning",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "Kom ihåg att ifall du avbokar ditt hembyte kan det ha en negativ inverkan på din hembytespartner, som kanske redan har planerat sin resa!",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återgäldas till dig.",
  pre_approval_modal_expiration_description: Cg,
  reasons_for_cancellation_double_booking_rental: Rg,
  reasons_for_cancellation_family_issues: Ag,
  reasons_for_cancellation_health_issues: zg,
  reasons_for_cancellation_home_damage: Dg,
  reasons_for_cancellation_moving: Lg,
  reasons_for_cancellation_needed: jg,
  reasons_for_cancellation_other: Pg,
  reasons_for_cancellation_transportation_issues: Ig,
  reasons_for_cancellation_trust_issues: Vg,
  reasons_for_cancellation_work_related: Fg,
  reasons_other_comment_needed: Mg
}, Zg = "en", _a = ru({
  fallbackLng: Zg,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: {
    da: {
      common: du,
      conversations: Su
    },
    de: {
      common: Au,
      conversations: qu
    },
    en: {
      conversations: fd,
      common: Xu
    },
    en_US: {
      conversations: zd,
      common: yd
    },
    es: {
      conversations: ef,
      common: Md
    },
    fr: {
      conversations: xf,
      common: cf
    },
    hr: {
      conversations: qf,
      common: Af
    },
    it: {
      conversations: fh,
      common: Xf
    },
    nb: {
      conversations: zh,
      common: yh
    },
    nl: {
      conversations: eg,
      common: Mh
    },
    pt: {
      conversations: wg,
      common: lg
    },
    sv: {
      conversations: Ug,
      common: Eg
    }
  }
});
_a.init();
const ns = _a, Bg = (n, e) => {
  ga("exchange_status", n, e);
}, tp = (n, e) => {
  const t = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return ls(new Date(n), e).toLocaleDateString(document.body.dataset.locale, t);
}, np = (n, e, t) => {
  const r = ls(new Date(e), t);
  return new Date(n) > r;
}, Yn = "warning_step", ba = "reason_step", qg = {
  [Yn]: Dc,
  [ba]: zc
};
function Hg({
  cancellationReasons: n,
  conversation: e,
  user: t
}) {
  const [r, s] = Me(Yn), a = qg[r], { url: o } = lr(`/conversations/${e.id}`);
  return pt(() => {
    var c;
    const i = Ic({
      isHeCollection: t.is_he_collection,
      subscriptionEndOn: (c = t == null ? void 0 : t.subscription) == null ? void 0 : c.end_on
    });
    jc(t.id, i, t.is_he_collection);
  }, [t]), /* @__PURE__ */ v(al, { color: "primary", isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ v(el, { children: /* @__PURE__ */ v(
    a,
    {
      cancellationReasons: n,
      conversation: e,
      user: t,
      onClickContinue: () => {
        r === Yn ? (Pc("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: t.is_he_collection
        }), scrollTo(0, 0), s(ba)) : window.location.assign(o);
      }
    }
  ) }) });
}
function rp({ cancellationReasons: n, conversation: e, locale: t, user: r, apiUrl: s }) {
  return ns.changeLanguage(t), Ta(s), /* @__PURE__ */ v(gl, { locale: t, children: /* @__PURE__ */ v(io, { i18n: ns, children: /* @__PURE__ */ v(Hg, { cancellationReasons: n, conversation: e, user: r }) }) });
}
const sp = "WITH-GP", ap = "RECIPROCAL", op = "RECIPROCAL-WITH-GP", ip = "NEW", lp = "ACCEPTED", cp = "EXPIRED", up = "MANUALLY_DECLINED", dp = "AUTOMATICALLY_DECLINED", fp = "PAST_DATES_DECLINE";
export {
  rp as CancellationPage,
  zc as ReasonStep,
  lp as STAY_REQUEST_STATUS_ACCEPTED,
  dp as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  cp as STAY_REQUEST_STATUS_EXPIRED,
  up as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  ip as STAY_REQUEST_STATUS_NEW,
  fp as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  ap as STAY_TYPE_RECIPROCAL,
  op as STAY_TYPE_RECIPROCAL_WITH_GP,
  sp as STAY_TYPE_WITH_GP,
  ep as TransportationBanner,
  Dc as WarningStep,
  Oa as cancel,
  pp as cancelPreApprobation,
  mp as changeStayRequestToNonReciprocal,
  _p as changeStayRequestToReciprocal,
  bp as createStayRequest,
  vp as getCancellationInformations,
  yp as getExchangeConfig,
  tp as getExpirationDate,
  wp as getStayRequest,
  xp as getV1StayRequest,
  kp as heFetch,
  ns as i18nConfig,
  Sp as isCancellationPossible,
  np as isStartDateAfterExpirationDate,
  $p as manualDecline,
  Np as preapproveExchange,
  Ta as setConversationsFetchConfig,
  Bg as trackExchangeStatus,
  Op as updateStayRequestDates
};
